import { CurrencyPipe } from '@angular/common';
import { inject, Component, ElementRef, HostBinding, HostListener, Injectable, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as d3 from "d3";
import { axisTickFormat } from '../chart-axis-format';
import { DialogService } from 'src/app/services/dialog.service';
import { FilterService } from 'src/app/services/filter.service';
import { KpiBreakdownHeatmapComponent } from '../kpi-breakdown-heatmap/kpi-breakdown-heatmap-chart.component';
import moment from 'moment';
import * as _ from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { PopupDeleteComponent } from '../../popup-delete/popup-delete.component';
import { CalculationService } from 'src/app/services/calculation.service';
import { Subscription } from 'rxjs';
import { NavigationService } from 'src/app/services/navigation.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

/**
 * DPM dashboard. Its comment threads are keyed by the widget's own `comment_type`
 * instead of the generic 'CCO' bucket every other control chart shares.
 */
const DPM_DASHBOARD_KEY = 20230515110017;

import { NoDataNotifierService } from 'src/app/services/no-data-notifier.service';
@Injectable({
  providedIn: 'root'
})
@Component({
    selector: 'app-control-chart',
    templateUrl: './control-chart.component.html',
    styleUrls: ['./control-chart.component.scss'],
    standalone: false
})
export class ControlChartComponent implements OnInit, OnChanges, OnDestroy {
  private readonly noDataNotifier = inject(NoDataNotifierService);

  reqSubcription: Subscription[] = [];
  @ViewChild('controlChartDiv', { static: true }) controlChartDiv!: ElementRef
  // @ViewChild('lineChart') lineChart!: ElementRef;
  @ViewChild("prompt", { static: true }) prompt!: ElementRef;
  @Input('data') data: any
  @Input('parentData') parentData: any
  @Input('error_name') error_name: any;
  @Input('pageKey') pageKey: any
  @Input('item') item: any
  @Input('config') config: any
  @Input('AllcommentData') AllcommentData: any
  @Input('heading') heading: string = ''
  // Payload identifying the single selection this chart was opened for (the status-overview tile
  // behind the control-chart popup). The settings icon reads it to scope its properties
  // fetch/save to that selection instead of the whole page filter.
  @Input('selectedScope') selectedScope: any
  @ViewChild('fs') fs!: ElementRef;
  navHeading=''
  isActive = false;
  noData: Boolean = false
  iconList: any[] = []
  @HostBinding('class.is-fullscreen') isFullscreen = false;
  ControlChartData: any = {};
  props: any;
  divId: any = "controlChartDiv";
  dataTurn: number = 0
  renderLinePopup: any = false
  initiateChart: boolean = false
  mytooltipData: any = '';
  tooltipVisible: boolean = false; isDataLoaded: boolean = false;
  pinTooltip: any = false; Annotations: boolean = false;
  pinningData: any = '';
  popUpdata: any
  searchValue: any = '';
  myAnnotationsData: any = '';
  employee_key: any
  messages: any = []
  pinningmessages: any = '';
  latestPinnedComment: any = null;
  showChangeSelection: boolean = true;
  status: 'normal' | 'anomaly' = 'normal'; // default or from input
  previousStatus: 'normal' | 'anomaly' = 'normal';
  commentText: string = '';

  // annotation comment var
  currenttooltipdata: any
  edit: any = false
  editIndex: any
  CommentData: any;
  commentIndex: any; routeType: any
  editedValue: any; isChecked: boolean = false;

  //sider Variables
  private sliderSize = 300;
  private handleRadius = 6;
  private currentMin = 0;
  private currentMax = 100;
  private margins = {left:10,top:20}
  private orientation = 'vertical';

  //Resize Variables
  private resizeObserver: ResizeObserver | null = null;
  private resizeTimeout: any = null;
  /** Width `plotChart()` last measured, so a resize that does not actually
   *  change the chart box does not trigger a redundant re-render. */
  private lastRenderedWidth: number | null = null;

  @ViewChild('customTemplate') customTemplate: any;
  @ViewChild('DeleteDialog') DeleteDialog: any;
  @HostListener('fullscreenchange', ['$event'])
  @HostListener('webkitfullscreenchange', ['$event'])
  @HostListener('mozfullscreenchange', ['$event'])
  @HostListener('MSFullscreenChange', ['$event'])
  screenChange(event: any) {
    if (!document.fullscreenElement) {
      this.closeFullscreen();
    }
  }
  // noData: Boolean = false
  colors: any = { "anomaly": "#D11044", "buffer values": "#FFCD4A", "normal": "#3AC97C" }
  kpitimecycle = [

    {
      "value": "W",
      "format": "DD MMM YYYY",
      "label": "Weekly"
    },
    {
      "value": "M",
      "format": "MMM YYYY",
      "label": "Monthly"
    },
    {
      "value": "Q",
      "format": "MMM YYYY",
      "label": "Quarterly"
    }
    // ,
    // {
    //   "value": "Y",
    //   "format": "YYYY",
    //   "label": "Yearly"
    // }
  ]
  dashboardKey:any
 
  constructor(
    private currency: CurrencyPipe, 
    public filterService: FilterService, 
    public dialog: MatDialog, 
    private route: ActivatedRoute, 
    private dialogService: DialogService, 
    public kpiChart: KpiBreakdownHeatmapComponent, 
    public calculationStd: CalculationService,
    public navigationService: NavigationService,
    private dashboardService: DashboardService
  ) {
    
    this.route.params.subscribe((p: any) => {
      // Query Params
      this.route.queryParams.subscribe((params:any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        this.routeType = decryptedParams["cardId"];
        this.dashboardKey = decryptedParams["ds_key"];
      });
    });

    var empkey: any = sessionStorage.getItem("employee_key");
    this.employee_key = JSON.parse(empkey);

    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe((query: any) => {
        this.start()
        // this.getcommentsData()
      })
    )
  }

  //loade Method
  isLoading = false;
  async stop(ms: number): Promise<void> {
    return new Promise<void>(resolve => setTimeout(resolve, ms));
  }
  start() { this.isLoading = true; }

  //  tooltip for this chart
  private showTooltip(type: any, pinning: any, myX: any, myY: any, myData: any, chartWidth: any, chartHeight: any): void {
    this.currenttooltipdata = myData.currentValue
    if (this.filterService?.annotations) return
    // this.pinTooltip = !this.pinTooltip
    this.dataTurn = 0
    this.dataTurn = chartWidth - myX
     this.status = this.currenttooltipdata.status
     var [cmt_var,cmt_var1]:any = this.item.config.comments_data.split(',')
     var [chart_var,chart_var1]:any = this.item.config.chart_data.split(',')
    this.previousStatus = this.currenttooltipdata.status;
    if (type == 'pin') {
      this.pinningData = myData
      d3.select("#d3controlChartTooltip")
      .style('visibility', 'hidden');
      this.tooltipVisible = false
      this.pinningmessages = this.AllcommentData.filter((cmd: any) =>  this.sameRefresh(cmd['refresh_no'], this.pinningData.currentValue['refresh_seq_no']) &&cmd[cmt_var1]?.toString() == this.pinningData.currentValue[chart_var1]?.toString() && moment(cmd.period).format("yyyy-MM-DD") == moment(this.pinningData.xVal).format("yyyy-MM-DD") && cmd[cmt_var]?.toString() == this.pinningData.currentValue[chart_var]?.toString())
      this.setpinnedMessages(this.pinningmessages)
    } else {
      this.mytooltipData = myData
      this.mytooltipData.values.forEach((element: any) => {

        // if (this.item.config?.comment_type?.value == "dpmed" || this.item.config?.comment_type?.value == "dpmpd") {
        //   this.messages = this.AllcommentData.filter((cmd: any) => cmd.data_source_key == this.filterService.baseQuery?.['source_key'] && moment(cmd.period).format("yyyy-MM-DD") == moment(this.myAnnotationsData.period).format("yyyy-MM-DD") && cmd.kpi_key == this.currenttooltipdata?.['kpi_key']  )
        //   if (element.source_key == this.mytooltipData.currentValue.source_key && moment(element.period).format("yyyy-MM-DD") == moment(this.mytooltipData.xVal).format("yyyy-MM-DD") && element.kpi_key == this.mytooltipData.currentValue.kpi_key) {
        //     element['messages'] = this.AllcommentData.filter((cmd: any) => cmd.data_source_key == element.source_key && moment(cmd.period).format("yyyy-MM-DD") == moment(this.mytooltipData.xVal).format("yyyy-MM-DD") && cmd.kpi_key == element.kpi_key)
        //   }
        // }else{
          if (element.source_key == this.mytooltipData.currentValue.source_key && moment(element.period).format("yyyy-MM-DD") == moment(this.mytooltipData.xVal).format("yyyy-MM-DD") && element.kpi_key == this.mytooltipData.currentValue.kpi_key) {
           
            let value:any[] = this.AllcommentData.filter((cmd: any) =>   this.sameRefresh(cmd['refresh_no'], element['refresh_seq_no']) && cmd[cmt_var1]?.toString() == element[chart_var1]?.toString() && moment(cmd.period).format("yyyy-MM-DD") == moment(this.mytooltipData.xVal).format("yyyy-MM-DD") && cmd[cmt_var]?.toString() == element[chart_var]?.toString())
             
            let pinnedComments = value.filter(m => m.is_comment_pinned === 'Y');
           element['latestPinnedComment'] = pinnedComments.length
    ? pinnedComments.reduce((latest, current) =>
        new Date(current.insert_timestamp) > new Date(latest.insert_timestamp) ? current : latest
      )
    : null;
             element['messages']= value.filter(m => m !== element['latestPinnedComment']);
          // }
        }

       
      });
      // this.mytooltipData['messages'] = this.AllcommentData.filter((cmd: any) => cmd.data_source_key ==this.mytooltipData.currentValue.source_key && moment(cmd.period).format("yyyy-MM-DD") == moment(this.mytooltipData.xVal).format("yyyy-MM-DD")&& cmd.kpi_key==this.mytooltipData.currentValue.kpi_key )
    }
    if (this.pinningData?.values?.[0]?.index == this.mytooltipData?.values?.[0]?.index && type != 'pin') return

    // if (this.pinTooltip) {
    this.tooltipVisible = true
 const yposition=(myData.values[0].yPosition >= 280 && myData.values[0].yPosition <= 400 ? 300 : myData.values[0].yPosition)
    if (this.dataTurn < 550) {
      d3.select(type == "pin" ? "#d3pincontrolChartTooltip" : "#d3controlChartTooltip")
        .style('visibility', 'visible')
        .style('position', 'absolute')
        .style('top', (myData.values.length == 4 ? (0) : (yposition - 30)) + 'px')
        .style('right', (this.dataTurn + 60) + 'px')
        .style('left', 'unset')
        .style('z-index', type == "pin" ? 2 : 9)
    }
    else if (this.dataTurn > 550) {

      d3.select(type == "pin" ? "#d3pincontrolChartTooltip" : "#d3controlChartTooltip")
        .style('visibility', 'visible')
        .style('position', 'absolute')
        .style('top', (myData.values.length == 4 ? (0) : (yposition - 30)) + 'px')
        .style('left', (myX + 40) + 'px')
        .style('right', 'unset')
        .style('z-index', type == "pin" ? 2 : 9)
    }
    if (this.isFullscreen == true) {
      d3.select(type == "pin" ? "#d3pincontrolChartTooltip" : "#d3controlChartTooltip")
        .style('top', (myData.values.length == 4 ? (0) : (yposition - 30)) + 'px')
    } else { }
    // } else {
    //   this.tooltipVisible = false
    // 
    // if(this.pinningmessages.length>0||this.messages.length>0)
    // this.myFunction()

  }
  private chartDrag(myDates: any, myData: any): void {
    console.log(myDates)
    this.filterService.dragDate = myDates
  }
  apply() {
    let currentSelections: any = sessionStorage.getItem("currentSelections");
    currentSelections = JSON.parse(currentSelections);
    this.kpiChart.compareClick('route', undefined, currentSelections)
  }
  //  hiddTooltip
  hideTooltip(type: any): void {
    if (type == 'pin') {
      d3.select("#d3pincontrolChartTooltip")
        .style('visibility', 'hidden');
      this.pinningData = ''
    } else if (type == 'annotation') {
      d3.select("#d3annotationsTooltip")
        .style('visibility', 'hidden');
    } else if (type == 'hover') {
      d3.select("#d3controlChartTooltip")
        .style('visibility', 'hidden');
      this.tooltipVisible = false
    }
  }
  //  annotation comment tooltip For the Chart
  /**
   * Place the annotation popup beside the point it was opened for: to its right when it
   * fits, otherwise to its left, centred on it vertically and kept inside the card. In a
   * card too narrow for either side it goes below the point instead (above, if there is
   * no room below), centred on it horizontally.
   *
   * showComment's own offsets mix the svg's coordinates (offsetX, yPosition) with the
   * popup's positioned ancestor, which the widget card provides, so the popup landed
   * off by however far the svg sits inside that card - far enough to cover the point.
   * Measuring both boxes avoids that. Runs after render so the popup has its size.
   */
  private placeAnnotationPopup(target: Element): void {
    const popup = d3.select('#d3annotationsTooltip').node() as HTMLElement | null;
    const parent = popup?.offsetParent as HTMLElement | null;
    if (!popup || !parent) return;
    const box = parent.getBoundingClientRect();
    const dot = target.getBoundingClientRect();
    const gap = 16;
    const x = dot.left + dot.width / 2 - box.left - parent.clientLeft + parent.scrollLeft;
    const y = dot.top + dot.height / 2 - box.top - parent.clientTop + parent.scrollTop;
    const width = popup.offsetWidth;
    const height = popup.offsetHeight;
    const viewLeft = parent.scrollLeft;
    const viewTop = parent.scrollTop;
    const viewRight = viewLeft + parent.clientWidth;
    const viewBottom = viewTop + parent.clientHeight;
    const clamp = (v: number, min: number, max: number) => Math.max(min, Math.min(v, max));

    const fitsRight = x + gap + width <= viewRight;
    const fitsLeft = x - gap - width >= viewLeft;
    let left: number;
    let top: number;
    if (fitsRight || fitsLeft) {
      left = fitsRight ? x + gap : x - gap - width;
      top = clamp(y - height / 2, viewTop, viewBottom - height);
    } else {
      left = clamp(x - width / 2, viewLeft, viewRight - width);
      top = y + gap + height <= viewBottom ? y + gap : y - gap - height;
    }
    left = Math.max(viewLeft, left);
    top = Math.max(viewTop, top);

    // Anchor the edges that must not move. The popup still changes size after this -
    // the comment box grows by a row as you type and the "Please enter comments" line
    // comes and goes - so pin the side facing the point (right edge when it sits to the
    // left of it), and the bottom edge when growing downward would run past the card.
    // Offsets are from the padding box at scroll origin, hence clientWidth/clientHeight.
    const anchorRight = !fitsRight && fitsLeft;
    const anchorBottom = top + height + 40 > viewBottom;
    popup.style.left = anchorRight ? 'unset' : left + 'px';
    popup.style.right = anchorRight ? (parent.clientWidth - (left + width)) + 'px' : 'unset';
    popup.style.top = anchorBottom ? 'unset' : top + 'px';
    popup.style.bottom = anchorBottom ? (parent.clientHeight - (top + height)) + 'px' : 'unset';
  }

  private showComment(myX: number, myY: number, myData: any, chartWidth: any, chartHeight: any, target?: Element): void {

    // console.log(myData)
  this.messages = []
    this.getcommentsData();
    this.dataTurn = 0
    this.dataTurn = chartWidth - myX
    this.myAnnotationsData = myData
    this.status = this.myAnnotationsData.status
    this.previousStatus = this.myAnnotationsData.status;
    this.Annotations = true

    if (this.dataTurn < 550) {
      d3.select("#d3annotationsTooltip")
        .style('visibility', 'visible')
        .style('position', 'absolute')
        .style('background', 'black')
        .style('border-radius', '9px')
        // .style('top', (myData.yPosition) - 50 + 'px')
        .style('right', (this.dataTurn + 20) + 'px')
        .style('left', 'unset')
    }
    else if (this.dataTurn > 550) {

      d3.select("#d3annotationsTooltip")
        .style('visibility', 'visible')
        .style('position', 'absolute')
        .style('background', 'black')
        .style('border-radius', '9px')
        // .style('top', (myData.yPosition) - 50 + 'px')
        .style('left', (myX + 20) + 'px')
        .style('right', 'unset')
    }

    if ((chartHeight - myData.yPosition) > 250) {
      d3.select("#d3annotationsTooltip")
        .style('top', myData.yPosition + 45 + 'px')
        .style('bottom', 'unset')

    } else {
      d3.select("#d3annotationsTooltip")
        .style('bottom', ((chartHeight - myData.yPosition) - 70) + 'px')
        .style('top', 'unset')

    }
    if (target) {
      setTimeout(() => this.placeAnnotationPopup(target));
    }
    // if (this.isFullscreen == true) {
    //   d3.select("#d3annotationsTooltip")
    //     .style('top', (myData.yPosition) - 50 + 'px')
    // } else { }
    if (this.item.config?.comment_type?.value == "dpmed" || this.item.config?.comment_type == "demd") {
    this.messages = this.AllcommentData.filter((cmd: any) => cmd.data_source_key == this.filterService.baseQuery?.['source_key'] && moment(cmd.period).format("yyyy-MM-DD HH:mm:ss") == moment(this.myAnnotationsData.period).format("yyyy-MM-DD HH:mm:ss") && cmd.kpi_key == this.currenttooltipdata?.['kpi_key']&& this.sameRefresh(cmd['refresh_no'], this.currenttooltipdata?.['refresh_seq_no'])   )

    }else{
    this.messages = this.AllcommentData.filter((cmd: any) => cmd.data_source_key == myData.source_key && moment(cmd.period).format("yyyy-MM-DD") == moment(this.myAnnotationsData.period).format("yyyy-MM-DD") && cmd.kpi_key == this.filterService.baseQuery.kpi_key&& this.sameRefresh(cmd['refresh_no'], this.currenttooltipdata?.['refresh_seq_no']))
    this.setMessages(this.messages)
  }
    this.myFunction()
  }

  /**
   * Do a comment and a chart record belong to the same refresh?
   *
   * Both sides are defaulted to 0 before they are compared, and that is the whole
   * point of the method. A refresh_no of 0 is dropped on the way in — the comments
   * component posts `refresh_no: topic.refresh_no || undefined`, so the column is
   * stored as NULL — while the chart record still reports 0. Comparing them raw
   * asks whether `undefined == 0`, which is false, so a note added against a
   * refresh_no: 0 point appeared immediately (the insert response is applied
   * unfiltered) and was gone after a reload, because the filter could never match
   * it again.
   *
   * Normalising on the READ side rather than fixing the insert is deliberate:
   * posting a real 0 would match new notes and orphan every note already stored
   * against NULL. Same reasoning, and the same `?? 0` on both sides, as
   * status-overview/comments/comments.ts.
   *
   * Stringified because the two sides do not agree on type — refresh_no comes back
   * from the comments API and refresh_seq_no off the chart record, and one can be
   * a number where the other is a string.
   */
  private sameRefresh(commentRefreshNo: any, recordRefreshSeqNo: any): boolean {
    return (commentRefreshNo ?? 0).toString() === (recordRefreshSeqNo ?? 0).toString();
  }

  private deleteGroup(myGroup: string): void {
    // this.plotChart();
  }
  //  Add KPI Breakdown popup 
  openKpiDialog() {

    this.filterService.kpiBreakdownexecuteQuerypopup("100203").subscribe(
      (res: any) => {
        this.popUpdata = res == null ? [] : res;
        this.filterService.isDataLoaded = true;
      },
      (error: any) => {
        this.popUpdata = [];
      }
    )
    this.dialogService.openDialog(this.prompt)
  }
  private switchGroup(myGroup: string): void {
  }
  // closeFullScreen
  closeFullscreen(): void {
    this.isFullscreen = false;
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
    this.props.singleChartHeight = 320
    // this.props.chartHeight = 500
    this.isActive = false;
    setTimeout(() => {
      d3.select("#d3pincontrolChartTooltip")
        .style('visibility', 'hidden')
      d3.select("#d3controlChartTooltip")
        .style('visibility', 'hidden');
      d3.select("#d3annotationsTooltip")
        .style('visibility', 'hidden');
      this.plotChart()
    }, 100);
  }

  /**
   * Re-render the chart whenever its container box changes size.
   *
   * `plotChart()` measures the svg once (`getBoundingClientRect().width`) and
   * bakes that number into every scale, the brush extents and the axis, so the
   * chart keeps its old geometry until something re-plots it. A ResizeObserver
   * on the chart div is used instead of `window:resize` because the box also
   * changes without the window doing so - grid/widget re-layout, sidebar
   * collapse, the status-overview popup this chart is opened in, and fullscreen.
   */
  private setupResizeObserver(): void {
    const container = this.controlChartDiv?.nativeElement;
    if (!container || typeof ResizeObserver === 'undefined') return;

    this.resizeObserver = new ResizeObserver(() => {
      if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.redrawOnResize(), 200);
    });
    this.resizeObserver.observe(container);
  }

  /** The width `plotChart()` works with, measured the same way it measures it. */
  private measureChartWidth(): number {
    const svgNode: any = d3.select('#svg_' + this.divId).node();
    return svgNode ? svgNode.getBoundingClientRect().width - 26 : 0;
  }

  private redrawOnResize(): void {
    // The first observer callback fires on attach, before the data/props are in
    // (props is read all through plotChart), and `noData` hides the div entirely.
    if (!this.props || this.noData) return;
    if (!this.ControlChartData?.data?.length || !this.ControlChartData?.properties?.length) return;

    const width = this.measureChartWidth();
    // 0 => the div is display:none or detached. Sub-pixel deltas come from
    // fractional layout rounding, not a real resize.
    if (width <= 0) return;
    if (this.lastRenderedWidth !== null && Math.abs(width - this.lastRenderedWidth) < 1) return;

    // The tooltips are positioned in px against the geometry of the previous
    // plot, and plotChart() resets its own pin state, so drop them first -
    // same clean-up ngOnChanges and closeFullscreen() do before re-plotting.
    d3.select("#d3pincontrolChartTooltip")
      .style('visibility', 'hidden');
    d3.select("#d3controlChartTooltip")
      .style('visibility', 'hidden');
    d3.select("#d3annotationsTooltip")
      .style('visibility', 'hidden');
    this.tooltipVisible = false;
    this.pinningData = '';

    this.plotChart();
  }
  annotationValue(value: any, event: any) {
    event.stopPropagation()
    if (value == '' || value == ' ') return
    this.searchValue = ''
    document.getElementById('comment')?.focus()
  }
  ngOnInit(): void {
    this.start()
    this.filterService.annotations = false
    this.initiateCharts();
    this.setupResizeObserver();
    // this.getcommentsData()
    this.iconList = this.item.config.icon ? this.item.config.icon : this.iconList
    if (this.iconList) {
      // this.getControlChartData();
    }

    // document.addEventListener('fullscreenchange', (event) => {
    //   this.isFullscreen = !this.isFullscreen
    //   this.initiateCharts();

    // })
  }
  // data change Event
  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']?.currentValue != changes['data']?.previousValue && this.initiateChart) {
      setTimeout(() => {
        this.getControlChartData();
      }, 200);
      d3.select("#d3pincontrolChartTooltip")
        .style('visibility', 'hidden')
      d3.select("#d3controlChartTooltip")
        .style('visibility', 'hidden');
      d3.select("#d3annotationsTooltip")
        .style('visibility', 'hidden');
      this.pinningData = ''
      this.filterService.settingpopupclose.next(false)
    }
  }
  //  d3 chart initial structure
  initiateCharts(): void {
    // only need to call this once on initialisation
    const myChart = this;
    const myClass = myChart.divId;

    const mySvg = d3.select('#' + myClass)
      .append('svg')
      .attr('id', 'svg_' + myClass)
      .attr("width", '100%')
      .style('background-color', 'white');

    const defs = mySvg.append('defs');

    defs.append('clipPath').attr('id', 'chartClip' + myClass)
      .append('rect').attr('id', 'chartClipRect' + myClass);

    defs.append('clipPath').attr('id', 'dotClip' + myClass)
      .append('rect').attr('id', 'dotClipRect' + myClass);

      defs.append('clipPath').attr('id', 'alcClip' + myClass)
      .append('rect').attr('id', 'alcClipRect' + myClass);

    const filter = defs.append('filter').attr('id', 'drop-shadow').attr('width', 10).attr('height', 24);
    filter.append('feGaussianBlur').attr('in', 'SourceAlpha').attr('stdDeviation', 1).attr('result', 'blur');
    filter.append('feOffset').attr('in', 'blur').attr('dx', 1)
      .attr('dy', 1).attr('result', 'offsetBlur');
    filter.append('feFlood').attr('in', 'offsetBlur')
      .attr('flood-color', '#000000').attr('flood-opacity', 0.4)
      .attr('result', 'offsetColor');
    filter.append('feComposite').attr('in', 'offsetColor').attr('in2', 'offsetBlur').attr('operator', 'in').attr('result', 'offsetBlur');
    const feMerge = filter.append('feMerge');
    feMerge.append('feMergeNode').attr('in', 'offsetBlur');
    feMerge.append('feMergeNode').attr('in', 'SourceGraphic');
    mySvg.append('g').attr('id', 'legendGroup' + myClass);

    mySvg.append('g').attr('class', 'titleGroup');
    mySvg.append('g').attr('class', 'chartsGroup');

    mySvg.append('g').attr('id', 'xAxis' + myClass);
    mySvg.append('text').attr('id', 'xAxisLabel' + myClass);
    mySvg.append('text').attr('id', 'yAxisLabel' + myClass);
    mySvg.append("path").attr("class", "brushPath");
    mySvg.append("path").attr("class", "brushArea");
    mySvg.append('g').attr('id', 'brushGroup' + myClass);
    mySvg.append('g').attr('id', 'sliderGroup' + myClass).attr('class', 'slider' + myClass);
    mySvg.append('line').attr('class', 'handleLines' + myClass + ' handleLeftLine1' + myClass);
    mySvg.append('line').attr('class', 'handleLines' + myClass + ' handleLeftLine2' + myClass);
    mySvg.append('line').attr('class', 'handleLines' + myClass + ' handleRightLine1' + myClass);
    mySvg.append('line').attr('class', 'handleLines' + myClass + ' handleRightLine2' + myClass);
    mySvg.append('g').attr('id', 'brushSelectionGroup' + myClass);
    // various items for the brush selection (see below for explanation on what that is!)
    mySvg.append('rect').attr('id', 'brushSelectionDateRect' + myClass);
    mySvg.append('text').attr('class', 'brushSelectionDateRectLabel' + myClass);
    mySvg.append('text').attr('id', 'brushSelectionDateRectCloseLabel' + myClass);
    mySvg.append('g').attr('class', 'dotsGroup');


    mySvg.append("linearGradient")
      .attr("id", "gradientDown")
      .attr("gradientUnits", "userSpaceOnUse")
      .attr("x1", 0)
      .attr("x2", 0)
      .attr("y1", 0)
      .selectAll("stop")
      .data([
        { offset: "0%", color: "#DBDBDB" },
        { offset: "100%", color: "white" }
      ])
      .enter().append("stop")
      .attr("id", (d, i) => i === 0 ? "zeroStop" : "")
      .attr("offset", (d: any) => d.offset)
      .attr("stop-color", (d: any) => d.color);

    mySvg.append("linearGradient")
      .attr("id", "gradientUp")
      .attr("gradientUnits", "userSpaceOnUse")
      .attr("x1", 0)
      .attr("x2", 0)
      .attr("y1", 0)
      .selectAll("stop")
      .data([
        { offset: "0%", color: "white" },
        { offset: "100%", color: "#DBDBDB" }
      ])
      .enter().append("stop")
      .attr("id", (d, i) => i === 0 ? "zeroStop" : "")
      .attr("offset", (d: any) => d.offset)
      .attr("stop-color", (d: any) => d.color);
    this.initiateChart = true
  }
  // chart svg  plotChart rendering
  plotChart(): void {
    const myChart:any = this;
    const myClass = myChart.divId;
    const mySvg: any = d3.select('#svg_' + myClass);
    let width: any = mySvg.node().getBoundingClientRect().width - 26;
    // Renders driven from elsewhere (fullscreen enter/exit, data change) also
    // land here, so the resize check compares against every plot, not just its own.
    myChart.lastRenderedWidth = width;
    const singleChartHeight = myChart.props.singleChartHeight;
    let minimumChartHeight = myChart.props.minChartHeight;
    const thresholdRectHeight = 20;
    const commentIconPath = "M9.19784 11.3909L9.12364 11.6021C9.0792 11.7285 8.9405 11.7958 8.81367 11.7525L7.75554 11.3909H9.19784ZM8.98775 0.262578C9.50492 0.389938 9.8209 0.91243 9.69354 1.4296C9.57021 1.93037 9.07641 2.24253 8.57571 2.14618L8.39222 2.53393H11.2986C11.4334 2.53393 11.5433 2.64385 11.5433 2.77862V10.6569C11.5433 10.7916 11.4334 10.9015 11.2986 10.9015H3.5468C3.41203 10.9015 3.30211 10.7916 3.30211 10.6569V2.77862C3.30211 2.64385 3.41203 2.53393 3.5468 2.53393H7.85203L8.13497 1.93602C7.86396 1.70689 7.73011 1.33632 7.82072 0.968375C7.94808 0.451203 8.47057 0.135219 8.98775 0.262578ZM8.39222 2.53393H7.85203L7.13208 4.0553C7.07454 4.17725 7.12676 4.32275 7.24868 4.38029C7.37063 4.43783 7.51613 4.38561 7.57367 4.26369L8.39222 2.53393ZM5.11271 9.0657H9.73271C9.86785 9.0657 9.97739 8.95616 9.97739 8.82102C9.97739 8.68587 9.86785 8.57633 9.73271 8.57633H5.11271C4.97757 8.57633 4.86802 8.68587 4.86802 8.82102C4.86802 8.95613 4.97759 9.0657 5.11271 9.0657ZM5.11271 7.31619H9.73271C9.86785 7.31619 9.97739 7.20664 9.97739 7.0715C9.97739 6.93636 9.86785 6.82681 9.73271 6.82681H5.11271C4.97757 6.82681 4.86802 6.93636 4.86802 7.0715C4.86802 7.20664 4.97759 7.31619 5.11271 7.31619ZM5.11271 5.5667H9.73271C9.86785 5.5667 9.97739 5.45715 9.97739 5.32201C9.97739 5.18687 9.86785 5.07732 9.73271 5.07732H5.11271C4.97757 5.07732 4.86802 5.18687 4.86802 5.32201C4.86802 5.45715 4.97759 5.5667 5.11271 5.5667ZM2.81274 9.70198V2.77862C2.81274 2.37376 3.14194 2.04455 3.5468 2.04455H6.16257L3.25074 1.07387C3.12289 1.03126 2.98386 1.10077 2.94122 1.22863L0.469105 8.64453C0.426683 8.77177 0.495191 8.91008 0.622105 8.95344L2.81274 9.70198Z";
    const commentIconViewbox = "0 0 12 12";
    const pinIconPath = "M3.86836 8.13161L0.75 11.25M5.69725 3.18439L4.8368 4.04484C4.76661 4.11503 4.73152 4.15012 4.69154 4.178C4.65605 4.20276 4.61777 4.22324 4.57749 4.23904C4.53211 4.25684 4.48344 4.26658 4.38611 4.28604L2.36606 4.69005C1.8411 4.79504 1.57862 4.84754 1.45582 4.98593C1.34884 5.1065 1.29999 5.26785 1.32212 5.4275C1.34753 5.61077 1.53681 5.80005 1.91536 6.1786L5.8214 10.0846C6.19995 10.4632 6.38923 10.6525 6.5725 10.6779C6.73215 10.7 6.8935 10.6512 7.01407 10.5442C7.15246 10.4214 7.20496 10.1589 7.30995 9.63394L7.71396 7.61389C7.73342 7.51656 7.74316 7.46789 7.76096 7.42251C7.77676 7.38223 7.79724 7.34395 7.82199 7.30846C7.84988 7.26848 7.88497 7.23339 7.95516 7.1632L8.81561 6.30275C8.86048 6.25788 8.88292 6.23544 8.90758 6.21585C8.92949 6.19845 8.9527 6.18274 8.97699 6.16886C9.00434 6.15323 9.03351 6.14073 9.09184 6.11573L10.4669 5.52644C10.868 5.35452 11.0686 5.26856 11.1597 5.12965C11.2394 5.00818 11.2679 4.86017 11.239 4.71779C11.206 4.55499 11.0517 4.40068 10.7431 4.09208L7.90792 1.2569C7.59932 0.948299 7.44501 0.793996 7.28221 0.760991C7.13983 0.73213 6.99182 0.760634 6.87035 0.840308C6.73144 0.931417 6.64548 1.13199 6.47356 1.53314L5.88427 2.90816C5.85927 2.96649 5.84677 2.99566 5.83114 3.02301C5.81726 3.0473 5.80155 3.07051 5.78415 3.09242C5.76456 3.11708 5.74212 3.13952 5.69725 3.18439Z"
    const unPinIconPath = "M2.41495 4.82896C2.56658 4.78391 2.75168 4.74509 2.94662 4.7059L4.22136 5.98064L3.35269 6.15437C3.29196 6.16652 3.23742 6.17747 3.18822 6.18749C3.2236 6.22311 3.26291 6.26248 3.3067 6.30627L5.1667 8.16628L7.02674 10.0263C7.07053 10.0701 7.1099 10.1094 7.14552 10.1448C7.15554 10.0956 7.16649 10.041 7.17864 9.98032L7.35237 9.11165L8.62711 10.3864C8.58792 10.5813 8.5491 10.7664 8.50405 10.9181C8.45263 11.0912 8.3583 11.3528 8.13006 11.5553C7.8512 11.8027 7.47802 11.9157 7.10875 11.8645C6.8065 11.8226 6.5829 11.6573 6.44409 11.5418C6.30528 11.4263 6.14902 11.27 5.98665 11.1075L5.96608 11.087L4.63638 9.75727L2.19683 12.1968C1.90394 12.4897 1.42907 12.4897 1.13617 12.1968C0.843282 11.9039 0.843282 11.429 1.13617 11.1362L3.57572 8.69661L2.24604 7.36693L2.22548 7.34637C2.06307 7.184 1.90676 7.02773 1.79125 6.88892C1.67573 6.75011 1.51039 6.52651 1.46849 6.22426C1.41729 5.85499 1.53028 5.48181 1.77772 5.20295C1.98023 4.97471 2.24184 4.88038 2.41495 4.82896ZM8.86283 9.20789L7.58893 7.934C7.58891 7.9341 7.58896 7.93391 7.58893 7.934L5.39929 5.74401C5.39919 5.74403 5.39938 5.74398 5.39929 5.74401L4.12512 4.47018L2.24463 2.58936L3.12851 1.70547L11.3781 9.95505L10.4942 10.8389L8.86283 9.20789ZM9.1297 6.1761C9.10514 6.19013 9.08106 6.20497 9.05751 6.22059L10.1841 7.34715L11.2161 6.90485L11.2402 6.89453C11.4102 6.82172 11.581 6.74856 11.7178 6.67459C11.863 6.59616 12.0626 6.47014 12.2076 6.24894C12.3919 5.96799 12.4578 5.62565 12.3911 5.29635C12.3385 5.0371 12.2001 4.84598 12.0944 4.71924C11.9948 4.59973 11.8634 4.46837 11.7326 4.33766L11.7141 4.31911L9.0139 1.61894L8.99536 1.60039C8.86465 1.46964 8.73327 1.33822 8.61377 1.2386C8.48703 1.13295 8.29591 0.994481 8.03666 0.941926C7.70736 0.875171 7.36502 0.9411 7.08407 1.12538C6.86288 1.27046 6.73686 1.47 6.65842 1.61517C6.58445 1.75205 6.51129 1.92285 6.43849 2.0928L6.42815 2.11691L5.98586 3.14894L7.11242 4.2755C7.12804 4.25195 7.14288 4.22787 7.15691 4.20331C7.19422 4.13801 7.22271 4.07112 7.24065 4.02903L7.24564 4.01734L7.80687 2.70779L7.85928 2.58583L7.95324 2.6796L10.6534 5.37977L10.7472 5.47373L10.6252 5.52614L9.31567 6.08737L9.30397 6.09237C9.26188 6.1103 9.195 6.1388 9.1297 6.1761ZM2.91144 5.88623L2.91372 5.88986C2.91207 5.88741 2.91137 5.88622 2.91144 5.88623ZM2.79472 6.28286L2.79082 6.28461C2.79075 6.28459 2.79199 6.28399 2.79472 6.28286ZM7.99562 2.29849L7.994 2.30083C7.99507 2.2992 7.99562 2.29845 7.99562 2.29849ZM7.62836 2.37125L7.62598 2.36968C7.62598 2.36964 7.62676 2.37013 7.62836 2.37125ZM10.9633 5.70703L10.9618 5.70465C10.9629 5.70625 10.9634 5.70703 10.9633 5.70703ZM11.0322 5.33901L11.0345 5.33739C11.0346 5.3374 11.0338 5.33794 11.0322 5.33901ZM7.0484 10.5422L7.05015 10.5383L7.04895 10.5411C7.0486 10.5419 7.04841 10.5422 7.0484 10.5422ZM7.44315 10.4193L7.44678 10.4216C7.4468 10.4216 7.44561 10.4209 7.44315 10.4193Z";
    const iconViewBox = '0 0 10 7';
    const downIconPath = 'M0.313868 7H3.49922C3.67246 7 3.81309 6.85487 3.81309 6.67564V6.02045C3.81309 5.84142 3.67246 5.69609 3.49922 5.69609H2.15371L4.90684 2.8511L6.07402 4.05732C6.32051 4.31184 6.71992 4.31184 6.96641 4.05732L9.90801 1.01694C10.0307 0.890384 10.0307 0.684907 9.90801 0.558351L9.45977 0.0949173C9.3373 -0.0316386 9.13848 -0.0316386 9.01602 0.0949173L6.52012 2.67428L5.35313 1.46806C5.10666 1.21327 4.70719 1.21317 4.46074 1.46806L1.26172 4.77406V3.38356C1.26172 3.20453 1.12129 3.0592 0.947851 3.0592H0.313868C0.140429 3.0592 0 3.20453 0 3.38356V6.67564C0 6.85487 0.140429 7 0.313868 7Z';
    const upIconPath = 'M9.68613 0H6.50078C6.32754 0 6.18691 0.145126 6.18691 0.324363V0.979549C6.18691 1.15858 6.32754 1.30391 6.50078 1.30391H7.84629L5.09316 4.1489L3.92598 2.94268C3.67949 2.68816 3.28008 2.68816 3.03359 2.94268L0.0919922 5.98306C-0.0306641 6.10962 -0.0306641 6.31509 0.0919922 6.44165L0.540234 6.90508C0.662695 7.03164 0.861523 7.03164 0.983984 6.90508L3.47988 4.32572L4.64687 5.53194C4.89334 5.78673 5.29281 5.78683 5.53926 5.53194L8.73828 2.22594V3.61644C8.73828 3.79547 8.87871 3.9408 9.05215 3.9408H9.68613C9.85957 3.9408 10 3.79547 10 3.61644V0.324363C10 0.145126 9.85957 0 9.68613 0Z';
    let isPinned = false;
    let pinId = "";

    myChart.showChangeSelection = (this.item.config?.show_change_selection?.value ?? 'true') === 'true';

    const margins = { top: 20, bottom: 20, brush: 52, mid: 30, chartLeft: 60, chartRight: 10, chartTop: 10, chartBottom: 35 };
    margins.mid = myChart.props.xAxisVisible ? 30 : 0;
    margins.top = myChart.ControlChartData.properties.length === 1 && myChart.props.showDragSelect ? 40 : 40;
    if (myChart.props.staticPlot) {
      margins.brush=0
      margins.mid=0
    }
      // Bar Slider
      myChart.barMin = undefined;
      myChart.barMax = undefined;
      // Line Slider
      myChart.lineMin = undefined;
      myChart.lineMax = undefined;
      
    const tickFormat: any = { "D": "%d %b %y", "W": "%d %b %y ", "M": "%b %Y", "Q": "%b %Y", "Y": "%Y", "PCQ": "Q%q %Y" };
    const timeStampFormat: any = { "D": "%d %b %y %H:%M:%S", "W": "%d %b %y %H:%M:%S", "M": "%b %Y", "Q": "%b %Y", "Y": "%Y", "PCQ": "Q%q %Y" };
    const timePeriod = myChart.props.period;
    const xTickFormat: any = d3.timeFormat(tickFormat[timePeriod]);
    //establish distinct charts and get properties
    const kpiProperties: any = {};
    const headerLabels: any = {};
    const dotRadius = 8;
    let uniqueCharts: any = new Set();
    myChart.ControlChartData.data.forEach((d: any) => {
      // Unique charts chart with different source, kpi, and location names!
      const myVal = d[myChart.props.sourceVar].replace(/ /g, '') + ":" + d[myChart.props.kpiVar].replace(/ /g, '') + (d["sp_location_name"] ? `:${d["sp_location_name"]?.replace(/ /g, '')}` : "");
      headerLabels[myVal] = d[myChart.props.sourceVar] + ", " + d[myChart.props.kpiVar] + (d["sp_location_name"] ? `, ${d["sp_location_name"]}` : "");
      uniqueCharts.add(myVal);
    })
    uniqueCharts = Array.from(uniqueCharts);
    const isSingle = uniqueCharts.length === 1;
    minimumChartHeight = isSingle ? singleChartHeight : minimumChartHeight;
    const height = margins.top + margins.bottom + margins.brush + margins.mid + (uniqueCharts.length * minimumChartHeight);
    mySvg.attr("height", height);
    // y the x-axis group is translated to, shared with positionXAxisLabel() below -
    // it measures the tick labels from here to keep the axis title clear of them.
    const xAxisY = height - margins.mid - 10 - margins.bottom - margins.brush - 5;
    // Baseline-to-tick-label gap for the axis title (its own font-size + breathing room).
    const xAxisLabelGap = 18;
    uniqueCharts.forEach((d: any) => {
      const mySplit = String(d).split(":");
        kpiProperties[d] = myChart.ControlChartData.properties
          .find((f: any) => f[myChart.props.sourceVar].replace(/ /g, '') === mySplit[0] &&
            f[myChart.props.kpiVar].replace(/ /g, '') === mySplit[1])
    })
    //establish date range
    myChart.ControlChartData.data.map((m: any) => m[myChart.props.dateVar] = new Date(m[myChart.props.dateVar]));
    let dateSet: any = new Set();
    myChart.ControlChartData.data.forEach((d: any) => dateSet.add(String(d[myChart.props.dateVar])));
    dateSet = Array.from(dateSet).map((m: any) => m = new Date(m));
    const chartData: any = [];
    uniqueCharts.forEach((d: any) => {
      const myProperties = kpiProperties[d];
      const myLookBack: any = myProperties[myChart.props.lookBackVar];
      const mySD: any = myProperties[myChart.props.sDVar];
      const mySplit = String(d).split(":");
      let lineData:any;
      // If the Unique chart also has location data then filter to have matching source, kpi, and location names
      if(mySplit.length === 3){
        lineData= myChart.ControlChartData.data
          .filter((f: any) => f[myChart.props.sourceVar].replace(/ /g, '') === mySplit[0] &&
            f[myChart.props.kpiVar].replace(/ /g, '') === mySplit[1] &&
            f["x_axis_value"].replace(/ /g, '') === mySplit[2]);
      }
      // We do not have location data so just filter for matching source, and kpi
      else{
        lineData= myChart.ControlChartData.data
          .filter((f: any) => f[myChart.props.sourceVar].replace(/ /g, '') === mySplit[0] &&
            f[myChart.props.kpiVar].replace(/ /g, '') === mySplit[1]);
      }
      //transform this..
      let valuesSoFar: any = [];
      const myThresholdRange = [myProperties[myChart.props.thresholdVars[0]],
      myProperties[myChart.props.thresholdVars[1]]];
      const myAverage = (d3.sum(lineData,(m: any) => m[myChart.props.valueVar]))/lineData.length
      //  d3.mean(lineData, (m: any) => m[myChart.props.valueVar]);
      const showCalculations = myProperties.showCalculations === "true" ? true : false;
      let previousValue: any = null
      lineData.forEach((l: any, i: any) => {
        if (i > 0) {
          if (l[myChart.props.valueVar] > previousValue) {
            l.change = "up";
          } else {
            l.change = "down";
          }
        }
        previousValue = l[myChart.props.valueVar];
        l.thresholdRange = myThresholdRange[0] === null ? null : myThresholdRange;
      })
     var yMin: any;
      var yMax: any;
      const hasEnoughPoints = lineData.length > 3;

      if (showCalculations && hasEnoughPoints) {
        yMin = d3.min(lineData, (m: any) =>
          Math.min(
            0,
            m[myChart.props.valueVar],
            m.lowerLimit ?? m[myChart.props.valueVar]
          )
        );

        yMax = d3.max(lineData, (m: any) =>
          Math.max(
            m[myChart.props.valueVar],
            m.upperLimit ?? m[myChart.props.valueVar]
          )
        );
      } else {
        yMin = d3.min(lineData, (m: any) => m[myChart.props.valueVar]);
        yMax = d3.max(lineData, (m: any) => m[myChart.props.valueVar]);
      }
      if (yMin === yMax) {
        const padding = yMin === 0 ? 1 : Math.abs(yMin * 0.1);
        yMin = yMin - padding;
        yMax = yMax + padding;
      }

      if (myThresholdRange[0] !== null) {
        yMin = d3.min(lineData, (m: any) => showCalculations ? (Math.min(0, m[myChart.props.valueVar], m.lowerLimit, m.thresholdRange[0])) : m[myChart.props.valueVar]);
        yMax = d3.max(lineData, (m: any) => showCalculations ? (Math.max(m[myChart.props.valueVar], m.upperLimit, m.thresholdRange[1])) : m[myChart.props.valueVar]);
      }
      const pointData = lineData.map((item: any) => {
        item.average = myAverage;
        return item;
      });
      let lineRenderData = [...pointData];
      if (pointData.length === 1) {
        const single = { ...pointData[0] };

        single[myChart.props.dateVar] =
          new Date(new Date(single[myChart.props.dateVar]).getTime() + 1);

        lineRenderData = [pointData[0], single];
      }

      yMax = yMax < 30 ? 30 : yMax;
      yMin = yMin ? yMin : 1;
      // @ts-ignore
      chartData.push({
      yScale: d3.scaleLinear()
        .domain([yMin, yMax])
        .range([minimumChartHeight - margins.chartTop - margins.chartBottom, 0]),

      source: mySplit[0],
      kpi: mySplit[1],
      location: mySplit.length === 3 ? mySplit[2] : null,

      /** 👇 IMPORTANT */
      lineData: pointData,          // real data (dots, tooltip)
      lineRenderData: lineRenderData, // visual-only (line path)

      uniqueVar: d,
      average: myAverage,
      thresholdRange: myThresholdRange[0] === null ? null : myThresholdRange,
      showCalculations
    });
  })
    const selectionYScale = chartData.length === 1 ? chartData[0].yScale : undefined;
    const tooltipInfoByDate: any = {};
    dateSet = dateSet.sort((a: any, b: any) => d3.ascending(a, b));
    dateSet.forEach((d: any, dateIndex: any) => {
      const tooltipData: any = [];
      chartData.forEach((c: any, i: any) => {
        const myDateEntry = c.lineData.find((f: any) => String(f[myChart.props.dateVar])
          === String(d));
        if (myDateEntry !== undefined) {
          if (dateIndex > 0) {
            const previousValue = tooltipInfoByDate[dateSet[dateIndex - 1]]?.[i]?.value;
            myDateEntry.difference = myDateEntry.value - previousValue;
            myDateEntry.percentDifference = myDateEntry.difference / previousValue;
            myDateEntry.differenceLabel = myDateEntry.difference < 0 ? "down" : myDateEntry.difference === 0 ? "none" : "up"
          }
          myDateEntry.uniqueVar = d;
          myDateEntry.yPosition = margins.top + (i * minimumChartHeight) + c.yScale(myDateEntry[myChart.props.valueVar]||0)
          tooltipData.push(myDateEntry);
        }
      })
      tooltipInfoByDate[d] = tooltipData;
    })
     const timeConverter: any = {
          D: d3.timeDay,
          W: d3.timeWeek,
          M: d3.timeMonth,
          Q: d3.timeMonth,
          Y: d3.timeYear,
          PCQ: d3.timeMonth,
        };
    const tickValues = myChart.props.d3AxisFormatting === true ? null : dateSet;
    const tickCount = myChart.props.d3AxisFormatting === true ? 6 : null;
    const brushYExtent = isSingle ? ( (chartData[0].yScale.domain()[1]<30) ? 30 : chartData[0].yScale.domain()[1]) : 0;
    const dotColorScale: any = d3.scaleOrdinal().domain(myChart.props.colorLabels).range(myChart.props.colors);
    const xExtent: any = d3.extent(myChart.ControlChartData.data, (d: any) => d[myChart.props.dateVar]);
    // xExtent[0] = timeConverter[timePeriod].offset(xExtent[0], -1);
    // xExtent[1] = timeConverter[timePeriod].offset(xExtent[1], 1);
    
    const yScaleBrush: any = d3.scaleLinear().range([margins.brush, 0]).domain([0, brushYExtent]);
    
    const xScaleAll: any = d3.scaleTime().range([0, width - margins.chartLeft - margins.chartRight]).domain(xExtent);
    
    let xScale: any;
    
    if (myChart.props.staticPlot) {
      xScale = d3.scalePoint()
        .domain(tickValues)
        .range([margins.chartLeft, width - margins.chartLeft - margins.chartRight]);  
        // .paddingInner(0.5)
        // .paddingOuter(0.5);
    } else {
      xScale = d3.scaleTime()
        .range([50, width - margins.chartLeft - margins.chartRight])
        .domain(xExtent);
    }

    var brush: any
    if (myChart.props.staticPlot) {
    drawChart();
    } else {
    brush = d3.brushX()
    .handleSize(10)
    .extent([[0, 0], [width - margins.chartLeft - margins.chartRight, margins.brush]])
    .on('start brush end', brushed);
    }
    const brushSelection = d3.brush()
      .extent([[0, 0], [width - margins.chartLeft - margins.chartRight, minimumChartHeight - margins.chartTop - margins.chartBottom]])
      .on('start', brushSelectedStart)
      .on('end', brushedSelected);

    if (chartData.length === 1 && myChart.props.showDragSelect) {
      mySvg.select('#brushSelectionGroup' + myClass)
        .attr('transform', 'translate(' + (margins.chartLeft + 5) + ',' + margins.top + ')')
        .call(brushSelection)
        .call(brushSelection.move, [[0, 0], [0, 0]]);
      
    } else {
      if (mySvg.select('#brushSelectionGroup' + myClass).selectAll(".overlay").node() !== null) {
        mySvg.select('#brushSelectionGroup' + myClass)
          .attr('transform', 'translate(' + margins.chartLeft + ',' + margins.top + ')')
          .call(brushSelection.move, null)
          .selectAll("*").remove();;
      }
    }

    const brushDateRectHeight = 30;
    const brushDateRectMinWidth = 45;

    mySvg.select('#brushSelectionDateRect' + myClass)
      .attr('stroke-width', 0)
      .attr('height', brushDateRectHeight)
      .attr('fill', '#878f99')
      .attr('fill-opacity', 0.7)
      .attr('transform', 'translate(' + margins.chartLeft + ',' + margins.top + ')');

    mySvg.select('.brushSelectionDateRectLabel' + myClass)
      .attr('fill', 'white')
      .attr('font-family', 'Poppins')
      .attr('font-weight', '500')
      .attr('font-size', '12')
      .attr('cursor', function () {
        // @ts-ignore
        const myText: any = d3.select(this).text();
        if (myText.includes('..')) {
          return 'pointer';
        } else {
          return 'default';
        }
      })
      .on('mousemove', function (event: any): void {
        // @ts-ignore
        const myText = d3.select(this).text();
        if (myText.includes('..')) {
          mySvg.select('.wrapTooltipRect' + myClass)
            // @ts-ignore
            .attr('width', measureWidth(this.id, 10) + 15)
            .attr('x', (event.offsetX + 10) + 'px')
            .attr('y', event.offsetY + 'px');

          mySvg.select('.wrapTooltipLabel' + myClass)
            .attr('x', (event.offsetX + 15) + 'px')
            .attr('y', (event.offsetY + 10.5) + 'px')
            // @ts-ignore
            .text(this.id);
        }
      })
      .on('mouseout', () => {
        mySvg.select('.wrapTooltipRect' + myClass)
          .attr('width', 0);
        mySvg.select('.wrapTooltipLabel' + myClass).text('');
      });

    mySvg.select('#brushSelectionDateRectCloseLabel' + myClass)
      .attr('y', '22')
      .attr('x', '-6')
      .attr('fill', 'white')
      .attr('font-family', 'Poppins')
      .attr('font-weight', '500')
      .attr('font-size', '16')
      .attr('cursor', 'pointer')
      .text(myChart.props.chartBrushAndPercents === true ? "x" : "")
      .attr('transform', 'translate(' + margins.chartLeft + ',' + margins.top + ')')
      .on('click', () => hideSelectBrush());

    function brushSelectedStart(): void {
      // clears everything from brush selection to get started
      mySvg.select('#selectionLeft' + myClass)
        .text('');

      mySvg.select('#selectionRight' + myClass)
        .text('');

      mySvg.select('#arrowLeft' + myClass)
        .attr('d', '');

      mySvg.select('#arrowRight' + myClass)
        .attr('d', '');

      mySvg.select('#brushSelectionDateRect' + myClass)
        .attr('width', 0);

      mySvg.select('#brushSelectionDateRectCloseLabel' + myClass)
        .text('');

      mySvg.select('.brushSelectionDateRectLabel' + myClass)
        .text('');
    }

    function brushedSelected(event: any): void {

      const selection = event.selection;
      if (selection === null) {
        myChart.filterService.dragDate = []
        drawSelectedLegend([]);
      }
      if (selection !== null && event.mode !== undefined && selectionYScale !== undefined) {
        // re-style selection box for the brush selection
        mySvg.selectAll('#brushSelectionGroup' + myClass)
          .selectAll('.selection').attr('class', 'selection lineSelectionBox');

        mySvg.selectAll('.lineSelectionBox')
          .style('fill', '#1363DF')
          .style('fill-opacity', '0.1')
          .style('stroke', '#1363DF')
          .style('stroke-width', '1')
          .style('stroke-dasharray', '15,15');

        //hide handles and tooltip, dotline and data dots
        mySvg.selectAll('#brushSelectionGroup' + myClass)
          .selectAll('.handle')
          .style('width', 0)
          .style('height', 0);

        // invert scales to get x and y domain
        const xDomain: any = [selection[0][0], selection[1][0]].map(xScale.invert);
        const yDomain: any = [selection[0][1], selection[1][1]].map(selectionYScale.invert);
        let filteredData = JSON.parse(JSON.stringify(chartData[0].lineData));
        filteredData.map((m: any) => m[myChart.props.dateVar] = new Date(m[myChart.props.dateVar]));
        filteredData.map((m: any) => m[myChart.props.valueVar] = +m[myChart.props.valueVar]);
        // filter to current selection data
        filteredData = filteredData.filter((f: any) => f[myChart.props.dateVar] >= xDomain[0] && f[myChart.props.dateVar] <= xDomain[1]);
        filteredData = filteredData.filter((f: any) => f[myChart.props.valueVar] >= yDomain[1] && f[myChart.props.valueVar] <= yDomain[0]);

        if (filteredData.length > 1) {
          const extent = d3.extent(filteredData, (e: any) => e[myChart.props.dateVar]);
          const valueExtent: any = d3.extent(filteredData, (e: any) => e[myChart.props.valueVar]);
          const firstValue = filteredData[0][myChart.props.valueVar];
          const lastValue = filteredData[filteredData.length - 1][myChart.props.valueVar];
          const legendNumberFormat = d3.format(".1f");
          const selectedLegendData = [
            // @ts-ignore
            { label: "Avg", value: legendNumberFormat(d3.mean(filteredData, (m: any) => m[myChart.props.valueVar])) },
            { label: "Lowest Number", value: legendNumberFormat(valueExtent[0]) },
            { label: "Highest Number", value: legendNumberFormat(valueExtent[1]) },
            { label: "Trend", value: d3.format(".0%")((lastValue - firstValue) / firstValue), actualValue: (lastValue - firstValue) / firstValue }
          ]
          myChart.chartDrag(extent, selectedLegendData);
          drawSelectedLegend(selectedLegendData)
          const first: any = extent[0];
          const last: any = extent[1];
          let positionLast = xScale(last);
          if ((xScale(last) - xScale(first)) < brushDateRectMinWidth) {
            positionLast = xScale(first) + brushDateRectMinWidth;
          }
          // calculate new extent and move brush selection
          // this snaps the users selection to the  actual bounds of the data
          // ie the user is unlikely to have got the x postion of an exact date in the data
          const dateFormat = d3.timeFormat('%d %b %Y');
          const newExtent = [[xScale(first), selection[0][1]], [positionLast, selection[1][1]]];
          // @ts-ignore
          d3.select(this).call(brushSelection.move, newExtent);
          // set the parameters and properties for the date rect and labels.
          mySvg.select('#brushSelectionDateRect' + myClass)
            .attr('x', xScale(first)+5)
            .attr('y', selection[0][1])
            .attr('width', positionLast - xScale(first));
          mySvg.select('.brushSelectionDateRectLabel' + myClass)
            .attr('transform', 'translate(' + (xScale(first) + margins.chartLeft + 5) + ',' + (margins.top + 15 + selection[0][1]) + ')')
            .text(dateFormat(first) + ' - ' + dateFormat(last))
            .call(wrap, positionLast - xScale(first) - 5);

          mySvg.select('#brushSelectionDateRectCloseLabel' + myClass)
            .text('x')
            .attr('transform', 'translate(' + (xScale(first) + margins.chartLeft
              + positionLast - xScale(first) - 10) + ',' + (margins.top + selection[0][1]) + ')');
        } else {
          drawSelectedLegend([]);
          // hideSelectBrush();
        }
      }
    }

    function hideSelectBrush(): void {
      // reset all properties so selection brush is hidden
      mySvg.select('#brushSelectionDateRect' + myClass)
        .attr('width', 0);

      mySvg.select('#brushSelectionDateRectCloseLabel' + myClass)
        .text('');

      mySvg.select('.brushSelectionDateRectLabel' + myClass)
        .text('');

      mySvg.select('#brushSelectionGroup' + myClass)
        .call(brushSelection.move, [[0, 0], [0, 0]]);
      mySvg.select('#selectionLeft' + myClass)
        .text('');

      mySvg.select('#selectionRight' + myClass)
        .text('');

      mySvg.select('#arrowLeft' + myClass)
        .attr('d', '');

      mySvg.select('#arrowRight' + myClass)
        .attr('d', '');
      myChart.filterService.dragDate = []
    }
    if (!myChart.props.staticPlot) {
    mySvg.select(".brushPath")
      .attr("fill", "transparent")
      .attr("stroke", "#8C23E6")
      .attr("d", isSingle ? d3.line()
        .x((l: any) => xScaleAll(l[myChart.props.dateVar]))
        .y((l: any) => yScaleBrush(l[myChart.props.valueVar]))
        (chartData[0].lineRenderData) : "")
      .attr("transform", "translate(" + margins.chartLeft + "," + (height - margins.bottom - margins.brush) + ")")

    mySvg.select(".brushArea")
      .attr("stroke-width", 0)
      .attr("fill", "#8C23E6")
      .attr("fill-opacity", 0.2)
      .attr("d", isSingle ? d3.area()
        .x((l: any) => xScaleAll(l[myChart.props.dateVar]))
        .y0((l: any) => yScaleBrush(l[myChart.props.valueVar]))
        .y1((l: any) => yScaleBrush(0))
        (chartData[0].lineData) : "")
      .attr("transform", "translate(" + margins.chartLeft + "," + (height - margins.bottom - margins.brush) + ")")
    }
    const brushStartX = 0;

    mySvg.select("#gradientDown")
      .attr("y2", thresholdRectHeight);

    mySvg.select("#gradientUp")
      .attr("y2", thresholdRectHeight);

      if (!myChart.props.staticPlot) {
    mySvg.select('#brushGroup' + myClass)
      .attr('transform', 'translate(' + margins.chartLeft + ',' + (height - margins.brush - margins.bottom) + ')')
      .call(brush)
      .call(brush.move, [brushStartX, width - margins.chartLeft - margins.chartRight]);

    mySvg.selectAll('.handleLines' + myClass)
      .attr('y1', height - margins.brush - margins.bottom + 6 + (margins.brush - 24) / 2)
      .attr('y2', height - margins.brush - margins.bottom + 18 + (margins.brush - 24) / 2)
      .style('stroke', '#8A98AB')
      .style('stroke-width', '1')
      .attr('transform', 'translate(' + margins.chartLeft + ',0)');
      }

 // axis labels
 positionXAxisLabel();

mySvg.select('#yAxisLabel' + myClass)
 .attr('visibility',  'visible')
 .attr('transform','translate(10,' + (margins.top + ((height - margins.top - margins.bottom - margins.mid - margins.brush)/2)) + ') rotate(-90)')
 .attr('text-anchor', 'middle')
 .attr('font-family', 'Poppins')
 .attr('fill', '#737D88')
 .attr('font-size', '12px')
 // @ts-ignore
 .text(myChart.props.yAxisLabel);


    mySvg.selectAll('#brushGroup' + myClass)
      .selectAll('.selection')
      .attr('fill', isSingle ? '#E8EAEE' : '#1363DF')
      .attr('fill-opacity', '0.2')
      .style('stroke', '#E8EAEE')
      .style('stroke-width', '1');

    mySvg.select('#chartClipRect' + myClass)
      .style('width', width - margins.chartLeft - margins.chartRight)
      .style('height', height - margins.chartTop - margins.brush - margins.mid - margins.chartBottom - margins.bottom -30 )
      .attr('transform', 'translate(' + (margins.chartLeft ) + ','+(margins.top)+')');

    mySvg.select('#dotClipRect' + myClass)
      .style('width', width - margins.chartLeft - margins.chartRight+10 + ((dotRadius + 1) * 2))
      .style('height', height - margins.chartTop - margins.brush - margins.mid - margins.chartBottom - margins.bottom- 20 )
      .attr('transform', 'translate(' + (margins.chartLeft ) + ','+margins.top+')');
      // .attr('transform', 'translate(' + (margins.chartLeft - (dotRadius + 1)) + ','+margins.top+')');

    drawLegend(myChart.props.legendItems)
    function drawChart() {
drawSelectedLegend([]);
// hideSelectBrush();
chartData[0].yScale.domain([
  myChart.lineMin !== undefined ? myChart.lineMin : 0,
  myChart.lineMax !== undefined ? myChart.lineMax : chartData[0].yScale.domain()[1]
]);

mySvg.select("#xAxis" + myClass)
  .attr("visibility", myChart.props.xAxisVisible ? "visible" : "hidden")
  .call(
    myChart.props.staticPlot
      ? d3.axisTop(xScale).tickFormat(xTickFormat)
      : d3.axisTop(xScale)
          .tickValues(
            tickValues === null
              ? null
              : tickValues.filter(
                  (f: any) => f >= xScale.domain()[0] && f <= xScale.domain()[1]
                )
          )
          .ticks(tickCount)
          .tickFormat(xTickFormat)
          .tickSizeOuter(0)
  )
  .attr(
    "transform",
    "translate(" +
      (myChart.props.staticPlot ? 50 : margins.chartLeft) +
      "," +
      xAxisY +
      ")"
  );

      mySvg.selectAll("#xAxis" + myClass + " path")
        .attr("display", "none");

        mySvg.selectAll("#xAxis" + myClass + " text")
        .text((d:any)=> (myChart.hasTimeDetails(d)) ? d3.timeFormat(timeStampFormat[timePeriod])(d): d3.timeFormat(xTickFormat)(d) )
        .call(textWrap, 55);


      let ticksArray = tickValues === null ? xScale.ticks() : tickValues.filter((f: any) => f >= xScale.domain()[0] && f <= xScale.domain()[1]);
      ticksArray = ticksArray.sort((a: any, b: any) => d3.ascending(a, b));
      const xBandwidth: any = d3.min(ticksArray, (m: any, i: any) => i === ticksArray.length - 1
        ? width - margins.chartRight - margins.chartLeft : xScale(ticksArray[i + 1]) - xScale(m))

      mySvg.selectAll("#xAxis" + myClass + " line")
        .attr("display", "none");

      const maxTextWidth = getMaxTextWidth();

      if (maxTextWidth > (xBandwidth - 5)) {
        let myFontSize = xBandwidth < myChart.props.axisFontSize + 2 ? xBandwidth - 2 : myChart.props.axisFontSize;

        mySvg.selectAll('#xAxis' + myClass + ' text')
          .style('font-family', 'Poppins')
          .style("text-anchor", "end")
          .style('font-size', myFontSize)
          //@ts-ignore
          .attr("dy", 3)
          //@ts-ignore
          .attr("transform", "rotate(-45)");
      } else {
        mySvg.selectAll('#xAxis' + myClass + ' text')
          .style('font-family', 'Poppins')
          .style("text-anchor", "middle")
          //@ts-ignore
          .attr("dy", 3)
          //@ts-ignore
          .attr("transform", "rotate(0)");
      }

      function getMaxTextWidth() {
        let maxTextWidth = 0;
        mySvg.selectAll('#xAxis' + myClass + ' text').each(function () {
          //@ts-ignore
          const myNode = d3.select(this).node().getBBox();
          maxTextWidth = Math.max(maxTextWidth, myNode.width)
        })
        return maxTextWidth
      }
      // dates header group
      const titleGroup = mySvg
        .select(".titleGroup")
        .selectAll('.titleGroup' + myClass)
        .data(chartData)
        .join(function (group: any): any {
          const enter = group.append('g').attr('class', 'titleGroup' + myClass);
          enter.append('text').attr('class', 'chartsTitle');
          enter.append('g').attr('class', 'yAxis');
          return enter;
        });

      titleGroup
        .attr("transform", (d: any, i: any) => "translate(0," + (margins.top + (i * minimumChartHeight)) + ")")
        .attr("id", (d: any, i: any) => "titleGroup" + i);

      titleGroup.select(".chartsTitle")
        .attr('fill', '#101D42')
        .attr('font-weight', '600')
        .attr('font-family', 'Poppins')
        .attr('font-size', '16')
        .attr('x', 20)
        .attr('pointer-events', 'none')
        .text((d: any) => chartData.length > 1 ? headerLabels[d.uniqueVar] : "");

      d3.selectAll('.titleGroup' + myClass).each((d: any, i: any) => {
        d3.select("#titleGroup" + i)
          .select(".yAxis")
          // @ts-ignore
          .call(d3.axisLeft(d.yScale).ticks(5).tickSizeOuter(0).tickFormat(axisTickFormat("-2~s")))
          .attr("transform", "translate(" + margins.chartLeft + "," + margins.chartTop + ")")
      })

      // dates header group
      const chartsGroup = mySvg
        .select(".chartsGroup")
        .attr('clip-path', 'url(#chartClip' + myClass + ')')
        .selectAll('.chartsGroup' + myClass)
        .data(chartData)
        .join(function (group: any): any {
          const enter = group.append('g').attr('class', 'chartsGroup' + myClass);
          enter.append('rect').attr('class', 'upperThresholdGradientRect');
          enter.append('rect').attr('class', 'lowerThresholdGradientRect');
          enter.append('line').attr('class', 'averageLine');
          enter.append('path').attr('class', 'valuePath');
          enter.append('path').attr('class', 'upperLimitPath');
          enter.append('circle').attr('class', 'upperLimitDot');
          enter.append('path').attr('class', 'lowerLimitPath');
          enter.append('circle').attr('class', 'lowerLimitDot');
          enter.append('path').attr('class', 'upperBufferArea');
          enter.append('path').attr('class', 'lowerBufferArea');
          enter.append('g').attr('class', 'dotGroup');
          return enter;
        });

      chartsGroup
        .attr("transform", (d: any, i: any) => "translate(0," + (margins.top + (i * minimumChartHeight)) + ")")
        .attr("id", (d: any, i: any) => "chartGroup" + i);

      chartsGroup.select(".chartsTitle")
        .attr('fill', '#101D42')
        .attr('font-weight', '600')
        .attr('font-family', 'Poppins')
        .attr('font-size', '16')
        .attr('pointer-events', 'none')
        .text((d: any) => headerLabels[d.uniqueVar]);

      chartsGroup.select(".upperThresholdGradientRect")
        .attr("display", (d: any) => d.showCalculations && d.thresholdRange !== null ? "block" : "none")
        .attr("width", width - margins.chartLeft - margins.chartRight)
        .attr("height", thresholdRectHeight)
        .attr("opacity", 0.3)
        .attr("fill", "url(#gradientDown)")
        .attr("transform", (d: any) =>
          "translate(" + margins.chartLeft + "," + (margins.chartTop
            + (d.thresholdRange === null ? 0 : d.yScale(kpiProperties[d.uniqueVar][myChart.props.thresholdVars[1]]))) + ")");

      chartsGroup.select(".lowerThresholdGradientRect")
        .attr("display", (d: any) => d.showCalculations && d.thresholdRange !== null ? "block" : "none")
        .attr("width", width - margins.chartLeft - margins.chartRight)
        .attr("height", thresholdRectHeight)
        .attr("opacity", 0.3)
        .attr("fill", "url(#gradientUp)")
        .attr("transform", (d: any) =>
          "translate(" + margins.chartLeft + "," + (margins.chartTop - 20 +
            (d.thresholdRange === null ? 0 : d.yScale(kpiProperties[d.uniqueVar][myChart.props.thresholdVars[0]]))) + ")");

      chartsGroup.select(".averageLine")
        .attr("display", (d: any) => d.showCalculations && myChart.props.showMeanLine ? "block" : "none")
        .attr("x1", margins.chartLeft)
        .attr("x2", width - margins.chartRight)
        .attr("y1", (d: any) => d.yScale(d.average))
        .attr("y2", (d: any) => d.yScale(d.average))
        .attr("stroke-width", 1)
        .attr("stroke", "#6A76A9")
        .attr("transform", (d: any) =>
          "translate(0," + margins.chartTop + ")");

      chartsGroup.select(".valuePath")
        .attr("fill", "none")
        .attr("stroke", "#8C23E6")
        .attr("stroke-width", 2)
        .attr("d", (d: any) => d3.line()
          .x((l: any) => xScale(l[myChart.props.dateVar]))
          .y((l: any) => d.yScale(l[myChart.props.valueVar]||0))(d.lineRenderData))
        .attr("transform", (d: any) => "translate(" + margins.chartLeft + "," + margins.chartTop + ")");

      chartsGroup.select(".lowerBufferArea")
        .attr("display", (d: any) => d.showCalculations ? "block" : "none")
        //   .attr("visibility", uniqueCharts.length === 1 ? "visible" : "hidden")
        .attr("fill", "#FFCD4A")
        .attr("fill-opacity", 0.2)
        .attr("d", (d: any) => d3.area()
          .defined((l: any) => l.lowerBuffer !== undefined)
          .x((l: any) => xScale(l[myChart.props.dateVar]))
          .y0((l: any) => d.yScale(l.lowerBuffer))
          .y1((l: any) => d.yScale(l.thresholdRange === null ? l.lowerLimit : Math.max(l.lowerLimit, l.thresholdRange[0])))(d.lineData))
        .attr("transform", (d: any) => "translate(" + margins.chartLeft + "," + margins.chartTop + ")");

      chartsGroup.select(".upperBufferArea")
        .attr("display", (d: any) => d.showCalculations ? "block" : "none")
        //   .attr("visibility", uniqueCharts.length === 1 ? "visible" : "hidden")
        .attr("fill", "#FFCD4A")
        .attr("fill-opacity", 0.2)
        .attr("d", (d: any) => d3.area()
          .defined((l: any) => l.upperBuffer !== undefined)
          .x((l: any) => xScale(l[myChart.props.dateVar]))
          .y0((l: any) => d.yScale(l.upperBuffer))
          .y1((l: any) => d.yScale(l.thresholdRange === null ? l.upperLimit : Math.min(l.upperLimit, l.thresholdRange[1])))(d.lineData))
        .attr("transform", (d: any) => "translate(" + margins.chartLeft + "," + margins.chartTop + ")");

      chartsGroup.select(".upperLimitPath")
        .attr("display", (d: any) => d.showCalculations ? "block" : "none")
        .attr("fill", "none")
        .attr("stroke", isSingle ? "#FFCD4A" : "#AFB2BF")
        .attr("stroke-dasharray", "4,4")
        .attr("stroke-width", 2)
        .attr("d", (d: any) => d3.line()
          .defined((l: any) => l.upperLimit !== undefined)
          .x((l: any) => xScale(l[myChart.props.dateVar]))
          .y((l: any) => d.yScale(l.upperLimit))(d.lineRenderData))
        .attr("transform", (d: any) => "translate(" + margins.chartLeft + "," + margins.chartTop + ")");

        chartsGroup.select(".lowerLimitPath")
        .attr("display", (d: any) => d.showCalculations ? "block" : "none")
        .attr("fill", "none")
        .attr("stroke", isSingle ? "#FFCD4A" : "#AFB2BF")
        .attr("stroke-dasharray", "4,4")
        .attr("stroke-width", 2)
        .attr("d", (d: any) => d3.line()
          .defined((l: any) => l.lowerLimit !== undefined)
          .x((l: any) => xScale(l[myChart.props.dateVar]))
          .y((l: any) => d.yScale(l.lowerLimit))(d.lineRenderData))
        .attr("transform", (d: any) => "translate(" + margins.chartLeft + "," + margins.chartTop + ")");
      chartsGroup.select(".upperLimitDot")
        .attr('cursor', 'default')
        .attr("r", 4)
        .attr("fill", "#FFCD4A")
        .attr("display", (d: any) =>
          d.showCalculations && d.lineRenderData?.length === 3
            ? "block"
            : "none"
        )
        .attr("cx", (d: any,index:any) => {
          if(d.lineRenderData?.length < 3)return
          const p = d.lineRenderData[2];
          return xScale(p[myChart.props.dateVar]) + margins.chartLeft-4;
        })
        .attr("cy", (d: any) => {
          if(d.lineRenderData?.length < 3)return
          const p = d.lineRenderData[2];
          const value = p.upperLimit ?? p[myChart.props.valueVar];
          return d.yScale(value) + margins.chartTop;
        })
        .raise()
        .selectAll("title")
        .data((d: any) => [d])
        .join("title")
        .text((d: any) => {
          const p = d.lineRenderData[2];
          return `Upper Control Limit: ${p?.upperLimit}`;
        });
      chartsGroup.select(".lowerLimitDot")
        .attr('cursor', 'default')
        .attr("r", 4)
        .attr("fill", "#FFCD4A")
        .attr("display", (d: any) =>
          d.showCalculations && d.lineRenderData?.length === 3
            ? "block"
            : "none"
        )
        .attr("cx", (d: any) => {
          if(d.lineRenderData?.length < 3)return
          const p = d.lineRenderData[2];
          return xScale(p[myChart.props.dateVar]) + margins.chartLeft-4;
        })
        .attr("cy", (d: any) => {
          if(d.lineRenderData?.length < 3)return
          const p = d.lineRenderData[2];
          const value = p.lowerLimit ?? p[myChart.props.valueVar];
          return d.yScale(value) + margins.chartTop;
        })
        .raise()
        .selectAll("title")
        .data((d: any) => [d])
        .join("title")
        .text((d: any) => {
          const p = d.lineRenderData[2];
          return `Lower Control Limit: ${p?.lowerLimit}`;
        });

      const dotsGroup = mySvg
        .select(".dotsGroup")
        .attr('clip-path', 'url(#dotClip' + myClass + ')')
        .selectAll('.dotsGroupGroup' + myClass)
        .data(chartData)
        .join(function (group: any): any {
          const enter = group.append('g').attr('class', 'dotsGroupGroup' + myClass);
          enter.append('g').attr('class', 'dotGroup');
          return enter;
        });

      dotsGroup.attr("transform", (d: any, i: any) => "translate(0," + (margins.top + (i * minimumChartHeight)) + ")")
        .attr("id", (d: any, i: any) => "chartGroup" + i);


      dotsGroup.select(".dotGroup")
        .attr("transform", (d: any) => "translate(" + margins.chartLeft + "," + margins.chartTop + ")");

      // dates header group
      const dotGroup = dotsGroup.select(".dotGroup")
        .selectAll('.dotsGroup' + myClass)
        .data((d: any, i: any) => {
          let myData = d.lineData;
          myData.map((m: any) => m.yScale = d.yScale);
          myData.map((m: any, index: any) => m.index = i + "_" + dateSet.findIndex((f: any) => String(f) === String(m[myChart.props.dateVar])));
          myData.map((m: any) => m.groupIndex = i);
          return myData;
        })
        .join(function (group: any): any {
          const enter = group.append('g').attr('class', 'dotsGroup' + myClass);
          enter.append('line').attr('class', 'dataDotLine');
          enter.append('circle').attr('class', 'dataDot');
          enter.append('svg').attr('class', 'dotIconSvg').append('path').attr('class', 'dotIconPath');
          enter.append('circle').attr('class', 'pinDot');
          enter.append('svg').attr('class', 'pinIconSvg').append('path').attr('class', 'pinIconPath');
          return enter;
        });

      dotGroup.select('.pinIconSvg')
        .attr("visibility", (d: any) => pinId === d.index.split("_")[1] ? "visible" : "hidden")
        .attr("id", (d: any) => "dotItem" + d.index)
        .attr('pointer-events', 'none')
        .attr("x", (d: any) => xScale(d[myChart.props.dateVar]) - 4)
        .attr("y", - 4 - (dotRadius * 2.5))
        .attr('viewBox', commentIconViewbox)
        .attr('width', 8)
        .attr('height', 8);

      dotGroup.select('.pinIconPath')
        .attr("id", (d: any) => "dotItem" + d.index.split("_")[1])
        .attr("visibility", (d: any) => pinId === d.index.split("_")[1] ? "visible" : "hidden")
        .attr('pointer-events', 'none')
        .attr('fill', 'white')
        .attr('stroke', 'white')
        .attr("stroke-width", 0.5)
        .attr('d', (d: any) => pinId === d.index.split("_")[1] ? pinIconPath : unPinIconPath);;

      dotGroup.select('.dotIconSvg')
        .attr("id", (d: any) => "dotItem" + d.index)
        .attr('pointer-events', 'none')
        .attr("x", (d: any) => xScale(d[myChart.props.dateVar]) - 5)
        .attr("y", (d: any) => d.yScale(d[myChart.props.valueVar]||0) - 5)
        .attr('viewBox', commentIconViewbox)
        .attr('width', 10)
        .attr('height', 10)

      dotGroup.select('.dotIconPath')
        .attr("id", (d: any) => "dotItem" + d.index)
        .attr('pointer-events', 'none')
        .attr('fill', 'white')
        .attr('d', (d: any) => d.comments == null ? "" : commentIconPath);

      dotGroup.select(".dataDotLine")
        .attr("id", (d: any) => "dotItem" + d.index.split("_")[1])
        .attr("visibility", (d: any) => pinId === d.index.split("_")[1] ? "visible" : "hidden")
        .attr("stroke-width", 2)
        .attr("stroke", "#1363DF")
        .attr("stroke-dasharray", "5,3")
        .attr("x1", (d: any) => xScale(d[myChart.props.dateVar]))
        .attr("x2", (d: any) => xScale(d[myChart.props.dateVar]))
        .attr("y1", (d: any) => uniqueCharts.length <= 4 ? 0 : d.yScale(d[myChart.props.valueVar]||0))
        .attr("y2", (d: any) => d.groupIndex === uniqueCharts.length - 1 ? minimumChartHeight - 45 : minimumChartHeight)

      dotGroup.select(".pinDot")
        .attr("visibility", (d: any) => pinId === d.index.split("_")[1] ? "visible" : "hidden")
        .attr("id", (d: any) => "dotItem" + d.index.split("_")[1])
        .attr("r", (d: any) => d[myChart.props.valueVar] === undefined ? 0 : dotRadius)
        .attr("stroke-width", (d: any) => d[myChart.props.valueVar] === undefined ? 0 : 2)
        .attr("stroke", "white")
        .attr("fill", "#1363DF")
        .attr("cx", (d: any) => xScale(d[myChart.props.dateVar]))
        .attr("cy", -(dotRadius * 2.5))

      dotGroup.select(".dataDot")
        .attr("id", (d: any) => "dotItem" + d.index)
        .attr("r", (d: any) => d[myChart.props.valueVar] === undefined ? 0 : dotRadius)
        .attr("stroke-width", (d: any) => d[myChart.props.valueVar] === undefined ? 0 : 2)
        .attr("stroke", "white")
        .attr("fill", (d: any) => dotColorScale(d.status))
        .attr("cx", (d: any) => xScale(d[myChart.props.dateVar]))
        .attr("cy", (d: any) => d.yScale(d[myChart.props.valueVar]||0))
        .on("mousemove", (event: any, d: any) => {
          d3.select(event.currentTarget)
            .attr("stroke", "#1363DF")
          mySvg.selectAll("#dotItem" + event.currentTarget.id.split("_")[1])
            .attr("visibility", "visible");
          myChart.showTooltip('hover', false, event.offsetX, null, {
            xVal: d[myChart.props.dateVar],
            xPosition: margins.chartLeft + (xScale(d[myChart.props.dateVar])),
            values: tooltipInfoByDate[d[myChart.props.dateVar]], currentValue: d
          }, width, height);

        })
        .on("mouseout", (event: any) => {
          if (pinId !== event.currentTarget.id.split("_")[1]) {
            mySvg.selectAll(".dataDot").attr("stroke", "white");
            mySvg.selectAll(".dataDotLine").attr("visibility", "hidden");
            mySvg.selectAll(".pinIconPath").attr("visibility", "hidden");
            mySvg.selectAll(".pinDot").attr("visibility", "hidden");
            if (pinId !== "") {
              d3.select(".dataDot #dotItem" + pinId)
                .attr("stroke", "#1363DF")
              mySvg.selectAll("#dotItem" + pinId)
                .attr("visibility", "visible");
            }
            myChart.hideTooltip('hover');
          }
        })
        .on("click", (event: any, d: any) => {
          let justPinned = false;
          if (event.shiftKey) {
            if (isPinned && pinId === event.currentTarget.id.split("_")[1]) {
              isPinned = false
              pinId = ""
            } else {
              isPinned = true;
              pinId = event.currentTarget.id.split("_")[1];
              justPinned = true;
              mySvg.selectAll(".dataDot").attr("stroke", "white");
              mySvg.selectAll(".dataDotLine").attr("visibility", "hidden");
              mySvg.selectAll(".pinIconPath").attr("visibility", "hidden");
              mySvg.selectAll(".pinDot").attr("visibility", "hidden");
              if (pinId !== "") {
                d3.select(".dataDot #dotItem" + pinId)
                  .attr("stroke", "#1363DF")
                mySvg.selectAll("#dotItem" + pinId)
                  .attr("visibility", "visible");
              }
            }
            if (isPinned) {
              if (!justPinned) {
                isPinned = false;
                pinId = "";
              }
              mySvg.selectAll(".pinIconPath").attr("d", unPinIconPath);
              mySvg.selectAll(".dataDot").attr("stroke", "white");
              mySvg.selectAll(".dataDotLine").attr("visibility", "hidden");
              mySvg.selectAll(".pinIconPath").attr("visibility", "hidden");
              mySvg.selectAll(".pinDot").attr("visibility", "hidden");
              d3.select(event.currentTarget)
                .attr("stroke", "#1363DF")
              mySvg.selectAll("#dotItem" + pinId)
                .attr("visibility", "visible");
              myChart.showTooltip("pin", isPinned, event.offsetX, event.offsetY, {
                xVal: d[myChart.props.dateVar],
                xPosition: margins.chartLeft + (xScale(d[myChart.props.dateVar])),
                values: tooltipInfoByDate[d[myChart.props.dateVar]], currentValue: d
              }, width, height);
            };
            if (!isPinned) {
              myChart.hideTooltip('pin');
            }
          } else {

            myChart.showComment(event.offsetX, event.offsetY, d, width, height, event.currentTarget)
          }
          mySvg.selectAll(".pinIconPath")
            .attr('d', (d: any) => pinId === d.index.split("_")[1] ? pinIconPath : unPinIconPath);
        });

      mySvg.selectAll(".yAxis path")
        .style('stroke', "#E8EAEE")
        .style('stroke-width', 1);

      mySvg.selectAll(".yAxis .tick text")
        .attr('fill', '#101D42')
        .attr('font-weight', '700')
        .attr('font-family', 'Poppins')
        .attr('font-size', '10')
        .attr('pointer-events', 'none')
        .style('stroke-width', 1);

      mySvg.selectAll(".yAxis line")
        .style('stroke', "#F0F3F6")
        .style('stroke-width', 1)
        .attr("x1", 0)
        .attr("x2", width - margins.chartLeft - margins.chartRight);

      // The tick labels have just been (re)wrapped/rotated, so the title's
      // clearance has to be re-measured against them.
      positionXAxisLabel();
    }

    /**
     * Draw the x-axis title below the tick labels, wherever they actually end.
     *
     * The tick labels are not a fixed height: `textWrap` stacks the overflow into
     * extra lines 12px apart, and when a label is wider than its band the whole
     * set is rotated -45deg, which hangs it ~30px below the axis line. A single
     * hard-coded offset fits one of those states and is overlapped by the others -
     * in static-plot mode, where the title sits closest to the axis, the rotated
     * labels ran straight through it. So the title is placed against the measured
     * bottom of the axis group instead, and the svg grows if that pushes it past
     * the bottom edge.
     *
     * Never moves the title ABOVE its original offset: in brush mode the space
     * under the axis belongs to the brush and the zoom slider.
     */
    function positionXAxisLabel(): void {
      const defaultY = height - margins.bottom - margins.brush + margins.mid
        + (myChart.props.staticPlot ? 15 : 37);
      let labelY = defaultY;

      const axisNode: any = mySvg.select('#xAxis' + myClass).node();
      // A hidden axis still reports its geometry (visibility, not display), so it
      // is skipped explicitly rather than measured.
      if (axisNode && myChart.props.xAxisVisible) {
        // getBBox on the group unions the tick text in the group's own space,
        // rotation included, and the axis line/domain path are display:none.
        const axisBox = axisNode.getBBox();
        labelY = Math.max(defaultY, xAxisY + axisBox.y + axisBox.height + xAxisLabelGap);
      }

      mySvg.select('#xAxisLabel' + myClass)
        .attr('visibility', 'visible')
        .attr('x', margins.chartLeft + ((width - margins.chartLeft - margins.chartRight) / 2))
        .attr('y', labelY)
        .attr('text-anchor', 'middle')
        .attr('font-family', 'Poppins')
        .attr('fill', '#737D88')
        .attr('font-size', '12px')
        // @ts-ignore
        .text(myChart.props.xAxisLabel);

      // Keep the title inside the svg once it has been pushed down. Only the
      // element's height attribute grows - `height` still drives every scale, so
      // this just releases the blank strip the title needs. Untouched when the
      // title stayed put, so the charts that already fit render as before.
      if (labelY > defaultY) {
        mySvg.attr('height', Math.max(height, labelY + 6));
      }
    }

    function drawLegend(legendData: any) {
      // append data to legend group
      const legendGroup = mySvg
        .selectAll('.legendGroup' + myClass)
        .data(legendData)
        .join((group: any) => {
          const enter = group.append('g').attr('class', 'legendGroup' + myClass);
          enter.append('circle').attr('class', 'legendCircle');
          enter.append('text').attr('class', 'legendLabel');
          enter.append('text').attr('class', 'legendSymbol');
          return enter;
        });
      // circle
      legendGroup.select('.legendCircle')
        .attr('id', (d: any, i: any) => 'circle_legendItem' + i)
        .attr('fill', (d: any) => d.fill)
        .attr('stroke', (d: any) => d.stroke)
        .attr('r', 6);
      // label
      legendGroup.select('.legendLabel')
        .attr('id', (d: any, i: any) => 'legendItem' + i)
        .attr('y', 4)
        .attr('fill', '#101D42')
        .attr('font-weight', '500')
        .attr('font-size', '12')
        .attr('font-family', 'Poppins')
        .text((d: any) => d.label.toUpperCase())

      // label
      legendGroup.select('.legendSymbol')
        .attr('id', (d: any, i: any) => 'symbol_legendItem' + i)
        .attr('y', (d: any) => d.symbolDY)
        .attr('fill', (d: any) => d.symbolFill)
        .attr('font-weight', '500')
        .attr('font-size', '16')
        .attr("text-anchor", "middle")
        .attr('font-family', 'Poppins')
        .text((d: any) => d.symbol)
      // loop through labels and position each group according to width of previous
      // same logic applied (but with slightly different criteria) in other legends
      let legendX = 0;
      mySvg.selectAll('.legendLabel').each(function (): any {
        //@ts-ignore
        const myObject = this;
        const myWidth: any = document.getElementById(myObject.id)?.getBoundingClientRect().width;
        d3.select(myObject).attr('x', legendX + 12);
        mySvg.select('#circle_' + myObject.id).attr('cx', legendX);
        mySvg.select('#symbol_' + myObject.id).attr('x', legendX);
        legendX += (25 + myWidth)
      });
      // transform
      legendGroup.attr("transform", "translate(" + ((width - legendX) / 2) + "," + 10 + ")");

    }

    function drawSelectedLegend(selectedLegendData: any) {

      // append data to legend group
      const legendSelectedGroup = mySvg
        .selectAll('.selectedLegendGroup' + myClass)
        .data(selectedLegendData)
        .join((group: any) => {
          const enter = group.append('g').attr('class', 'selectedLegendGroup' + myClass);
          enter.append('text').attr('class', 'legendSelectedLabel');
          enter.append('text').attr('class', 'legendValueLabel');
          enter.append('svg').attr('class', 'legendDirectionIconSvg').append('path').attr('class', 'legendDirectionIcon');
          return enter;
        });

      legendSelectedGroup.select('.legendDirectionIconSvg')
        .attr('id', (d: any, i: any) => 'icon_legendSelectedItem' + i)
        .attr('pointer-events', 'none')
        .attr('y', -4)
        .attr('viewBox', iconViewBox)
        .attr('width', 10)
        .attr('height', 10);

      legendSelectedGroup.select('.legendDirectionIcon')
        .style('fill', (d: any) => d.actualValue && d.actualValue > 0 ? '#3AC97C' : '#D11044')
        .attr('d', (d: any) =>
          d.label === "Trend" ? (d.actualValue && d.actualValue < 0 ? downIconPath : (!d.actualValue || d.actualValue === 0 ? "" : upIconPath)) : "");

      // label
      legendSelectedGroup.select('.legendSelectedLabel')
        .attr('id', (d: any, i: any) => 'legendSelectedItem' + i)
        .attr('y', 4)
        .attr('fill', '#737D88')
        .attr('font-weight', '500')
        .attr('font-size', '12')
        .attr('font-family', 'Poppins')
        .text((d: any) => d.label + ": ")
        .attr('text-anchor', 'end')

      // label
      legendSelectedGroup.select('.legendValueLabel')
        .attr('id', (d: any, i: any) => 'value_legendSelectedItem' + i)
        .attr('y', 4)
        .attr('fill', '#101D42')
        .attr('font-weight', '500')
        .attr('font-size', '10')
        .attr('font-family', 'Poppins')
        .text((d: any) => " " + d.value)

      // loop through labels and position each group according to width of previous
      // same logic applied (but with slightly different criteria) in other legends
      let legendX = 0;
      mySvg.selectAll('.legendSelectedLabel').each(function (d: any, i: any): any {
        //@ts-ignore
        const myObject = this;
        const myWidth: any = document.getElementById(myObject.id)?.getBoundingClientRect().width;
        const myValueWidth: any = document.getElementById("value_legendSelectedItem" + (i - 1))?.getBoundingClientRect().width;
        const currentValueWidth: any = document.getElementById("value_legendSelectedItem" + i)?.getBoundingClientRect().width;

        const myExtra = i === 0 ? myWidth : myWidth + (myValueWidth + 10)
        legendX += myExtra;
        mySvg.select('#' + myObject.id).attr('x', legendX - 2);
        mySvg.select('#value_' + myObject.id).attr('x', legendX + 2);
        mySvg.select('#icon_' + myObject.id).attr('x', legendX + 5 + (i === 0 ? 0 : currentValueWidth));
      });

      // transform
      legendSelectedGroup.attr("transform", "translate(" + ((width - legendX - 20) / 2) + "," + 30 + ")");
    }

    function brushed(event: any): void {
      if (!myChart.props.staticPlot){
      drawSelectedLegend([]);
      if (isSingle === true && myChart.props.showDragSelect) {
        hideSelectBrush();
      }
      const selection = event.selection;
      if (selection !== null) {
        const xDomain: any = selection.map(xScaleAll.invert);
        const dataRemaining: any = dateSet.filter((f: any) => f >= xDomain[0] && f <= xDomain[1]).length;
        if (dataRemaining < 2 && dataRemaining !== dateSet.length) {
          const previousStart = xScaleAll(xScale.domain()[0]);
          const previousEnd = xScaleAll(xScale.domain()[1]);

          mySvg.select('#brushGroup' + myClass)
            .call(brush.move, [previousStart, previousEnd]);
        } else {
          xScale.domain(xDomain);

          drawChart();

          const handleEastX = +mySvg.select('#brushGroup' + myClass).select('.handle--e').attr('x');
          const handleWestX = +mySvg.select('#brushGroup' + myClass).select('.handle--w').attr('x');

          mySvg.select('.handleLeftLine1' + myClass)
            .attr('x1', handleEastX + 3)
            .attr('x2', handleEastX + 3);

          mySvg.select('.handleLeftLine2' + myClass)
            .attr('x1', handleEastX + 7)
            .attr('x2', handleEastX + 7);

          mySvg.select('.handleRightLine1' + myClass)
            .attr('x1', handleWestX + 3)
            .attr('x2', handleWestX + 3);

          mySvg.select('.handleRightLine2' + myClass)
            .attr('x1', handleWestX + 7)
            .attr('x2', handleWestX + 7);

          mySvg.select('#brushGroup' + myClass)
            .selectAll('.handle')
            .attr('fill', 'white')
            .attr('rx', 4)
            .attr('ry', 4)
            .attr('y', (margins.brush - 24) / 2)
            .attr('height', 24)
            .style('filter', 'url(#drop-shadow)');
        }
      }
    }
  }

    function measureWidth(myText: any, myFontSize: any): any {
      const context: any = document.createElement('canvas').getContext('2d');
      context.font = myFontSize + 'px sans-serif';
      return context.measureText(myText).width;
    }
    const slider = mySvg.select('#sliderGroup' + myClass);

    // // Bar Slider
    // myChart.barMin = myChart.currentMin;
    // myChart.barMax = sbarMax;
    // createRangeSlider('bar', myChart.currentMin, sbarMax);
    
    // Line Slider 
    const ymax= chartData[0].yScale.domain()[1]
    if(myChart.props.slider){
    myChart.lineMin = myChart.currentMin;
    myChart.lineMax =  ymax;

    createRangeSlider('bar', myChart.currentMin, ymax);
    }
        function createRangeSlider(id: string, min: number, max: number): void {
          const sliderGroupId = `sliderGroup-${id}`;
          const sliderClass = `${id}-slider`;
        
          // Remove any existing slider group for this ID
          slider.select(`#${sliderGroupId}`).remove();
        
          // Create a new slider group
          const sliderGroup = slider.append('g').attr('id', sliderGroupId);
          // Scale setup for the slider
          const scale = d3.scaleLinear()
            .domain([min, max])
            .range(myChart.orientation === 'horizontal' ? [0, chartData[0].yScale.range()[0]] : [chartData[0].yScale.range()[0], 0])
            .clamp(true);
        
          // Drag event handlers for the min and max handles
          const dragMinHandle = d3.drag().on('drag', (event) => onDragMinHandle( sliderGroup,event, scale, sliderClass, id, min, max));
          const dragMaxHandle = d3.drag().on('drag', (event) => onDragMaxHandle( sliderGroup,event, scale, sliderClass, id, min, max));
        
          // Create the slider track and inset line
          sliderGroup.append('line')
            .attr('class', `${sliderClass} ${id}-track`)
            .attr(myChart.orientation === 'horizontal' ? 'x1' : 'y1', scale(min))
            .attr(myChart.orientation === 'horizontal' ? 'x2' : 'y2', scale(max))
            .attr('transform', `translate(${id === 'line' ? (width - margins.chartLeft + 40) : (margins.chartLeft )}, ${margins.top+10})`)
            .attr('stroke', '#ddd')
            .attr('stroke-width', 1);
        
          sliderGroup.append('line')
            .attr('class', `${sliderClass} ${id}-track-inset`)
            .attr(myChart.orientation === 'horizontal' ? 'x1' : 'y1', scale(min))
            .attr(myChart.orientation === 'horizontal' ? 'x2' : 'y2', scale(max + margins.top))
            .attr('transform', `translate(${id === 'line' ? (width - margins.chartLeft + 40) : (margins.chartLeft )}, ${margins.top+10})`)
            .attr('stroke', '#ddd')
            .attr('stroke-width', 1);
        
          // Tooltip setup
          const tooltip = d3.select('body').append('div')
            .attr('class', 'tooltip')
            .style('position', 'absolute')
            .style('padding', '5px')
            .style('background', '#fff')
            .style('border', '1px solid #ccc')
            .style('border-radius', '4px')
            .style('pointer-events', 'none')
            .style('opacity', 0);
        
          // Create Min and Max handles with hover and drag functionality
          createSliderHandle( sliderGroup,sliderClass, id, 'min', min, scale, dragMinHandle, tooltip);
          createSliderHandle(sliderGroup,sliderClass, id, 'max', max, scale, dragMaxHandle, tooltip);
        }
        function createSliderHandle(sliderGroup:any,sliderClass: string, id: string, handleType: string, value: number, scale: any, dragHandle: any, tooltip: any): void {
          const circleColor:string = handleType === 'min'? '#718EB6': '#69b3a2';
          
          // Hover effect layer
          const hoverLayer = sliderGroup.append('circle')
            .attr('class', `${sliderClass} ${id}-${handleType}-hover-layer`)
            .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', scale(value))
            .attr('transform', `translate(${id === 'line' ? (width - margins.chartLeft + 40) : (margins.chartLeft )}, ${margins.top+10})`)
            .attr('r', myChart.handleRadius + 8)
            .attr('fill', circleColor)
            .attr('opacity', 0)
            .attr('pointer-events', 'none');
          const handle = sliderGroup.append('circle')
            .attr('class', `${sliderClass} ${id}-${handleType}-handle`)
            .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', scale(value))
            .attr('transform', `translate(${id === 'line' ? (width - margins.chartLeft + 40) : (margins.chartLeft )}, ${margins.top+10})`)
            .attr('r', myChart.handleRadius)
            .attr('fill', circleColor)
            // Put clicked handle to bottom of DOM group so that it overlaps the other handle
            .on('mousedown', function(){
              handle.raise();
            })
            .call(dragHandle);
        
          // Handle hover effect
          handle.on('mouseover', function(event: any) {
            hoverLayer.transition().duration(200).attr('opacity', 0.4);  // Show hover layer
            // sliderGroup.select(`.${sliderClass}.${id}-track-inset`)
            //         .attr('stroke-width', 4)
            //         .attr('stroke', '#69b3a2');  // Change color on hover
              //  tooltip
              // .style('opacity', 1)
              // .html(`Max: ${id === 'bar' ? myChart.barMax : myChart.lineMax}`)
              // .style('left', `${event.pageX + 10}px`)
              // .style('top', `${event.pageY - 20}px`);
          })
          .on('mouseout', function() {
            hoverLayer.transition().duration(400).attr('opacity', 0);  // Hide hover layer
            // sliderGroup.select(`.${sliderClass}.${id}-track-inset`)
            //         .attr('stroke-width', 1)
            //         .attr('stroke', '#ddd');  // Revert to original color
                    // tooltip.style('opacity', 0);  // Hide tooltip on mouse out
          })
          .on('mousemove', function(event: any) {
            // Update tooltip position
            //  tooltip
            //   .style('opacity', 1)
            //   .html(`Max: ${id === 'bar' ? myChart.barMax : myChart.lineMax}`)
            //   .style('left', `${event.pageX + 10}px`)
            //   .style('top', `${event.pageY - 20}px`);
            // tooltip.style('left', `${event.pageX + 10}px`).style('top', `${event.pageY - 20}px`);
          });
        }
        
        function onDragMinHandle(sliderGroup:any,event: any, scale: any, sliderClass: string, id: string, min: number, max: number): void {
          const newPos = Math.max(scale(max), event[myChart.orientation === 'horizontal' ? 'x' : 'y'] - margins.top);
          const currentMin = Math.round(scale.invert(newPos) - 1);
          // If our drag is greater than the minimum edge and less than the Max handle
          if (currentMin >= min && currentMin <= (id === 'line' ? myChart.barMax - 5 : myChart.lineMax - 5)) {
            id === 'line'? myChart.barMin = currentMin : myChart.lineMin = currentMin;
            // update the chart minimum and set the handle to the new position
            updateSliderHandlePosition(sliderGroup,sliderClass, id, 'min', newPos);
            updateTrackInset(sliderGroup,scale, sliderClass, id, currentMin, max);
            drawChart();
          }
          // Our drag is less than the minimum edge of the axis
          else if (currentMin < min){
            id === 'line'? myChart.barMin = min : myChart.lineMin = min;
            // Set the handle position to the minimum edge of the axis
            updateSliderHandlePosition(sliderGroup,sliderClass, id, 'min', scale(min));
            updateTrackInset(sliderGroup,scale, sliderClass, id, min, max);
            drawChart();
          }
        }
        
        function onDragMaxHandle(sliderGroup:any,event: any, scale: any, sliderClass: string, id: string, min: number, max: number): void {
          const newPos = Math.min(scale(min), event[myChart.orientation === 'horizontal' ? 'x' : 'y'] - margins.top);
          const currentMax = Math.round(scale.invert(newPos) + 1);
          // If our drag is less than the maximum edge and more than the Min handle
          if (currentMax <= max && currentMax >= (id === 'line' ? myChart.barMin + 5 : myChart.lineMin + 5)) {
            id === 'line'? myChart.barMax = currentMax : myChart.lineMax = currentMax;
            // update the chart maximum and set the handle to the new position
            updateSliderHandlePosition(sliderGroup,sliderClass, id, 'max', newPos);
            updateTrackInset(sliderGroup,scale, sliderClass, id, min, currentMax);
            drawChart();
          }
          // Our drag is more than the maximum edge of the axis
          else if (currentMax > max){
            id === 'line'? myChart.barMax = max : myChart.lineMax = max;
            // Set the handle position to the maximum edge of the axis
            updateSliderHandlePosition(sliderGroup,sliderClass, id, 'max', scale(max));
            updateTrackInset(sliderGroup,scale, sliderClass, id, min, max);
            drawChart();
          }
        }
        function updateTrackInset(sliderGroup:any,scale: any, sliderClass: string, id: string, min: number, max: number): void {
          sliderGroup.select(`.${sliderClass}.${id}-track-inset`)
            .attr(myChart.orientation === 'horizontal' ? 'x1' : 'y1', scale(min))
            .attr(myChart.orientation === 'horizontal' ? 'x2' : 'y2', scale(max));
        }
        
        function updateSliderHandlePosition( sliderGroup:any,sliderClass: string, id: string, handleType: string, newPos: number): void {
          sliderGroup.select(`.${sliderClass}.${id}-${handleType}-handle`)
            .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', newPos);
            sliderGroup.select(`.${sliderClass}.${id}-${handleType}-hover-layer`)
            .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', newPos);
        }
             
    function wrap(text: any, width: any): void {
      text.selectAll('tspan').remove();
      let lineNumber = 0;
      const originalValue = text.text();
      text.each(function (): any {
        // @ts-ignore
        const text = d3.select(this);
        const words = text.text().split(/\s+/).reverse();
        let word = null;
        let line: any = [];
        const lineHeight = 1.1; // ems
        const dy = 0;
        let tspan = text.text(null).append('tspan').attr('x', 0).attr('y', 6).attr('dy', dy + 'em');
        while (word = words.pop()) {
          line.push(word);
          tspan.text(line.join(' '));
          // @ts-ignore
          if (tspan.node().getComputedTextLength() > width) {
            line.pop();
            tspan.text(line.join(' '));
            line = [word];
            if (word.trim().length > 0) {
              tspan = text.append('tspan').attr('x', 0).attr('y', 0).attr('dy', ++lineNumber * lineHeight + dy + 'em').text(word);

            }
          }
        }
      });
      if (lineNumber > 1) {
        text.selectAll('tspan').remove();
        text.attr('id', originalValue)
        text.text(originalValue.substr(0, 5) + '..');
      }
    }
    function textWrap(text: any, width: any): void {
      text.selectAll('tspan').remove();

      text.each(function(): any {
        let lineNumber = 0;
        //@ts-ignore
        const text = d3.select(this);
        const words = text.text().split(/\s+/).reverse();
        let word = null;
        let line: any = [];
        const lineHeight = 12;
        const dy = 0;
        let tspan: any = text.text(null).append('tspan').attr('x', 0).attr('y', 0).attr('dy', dy + 'px');
        while (word = words.pop()) {
          line.push(word);
          tspan.text(line.join(' '));
          if (tspan.node().getComputedTextLength() > width) {
            line.pop();
            if(line.length > 0){
              tspan.text(line.join(' '));
              line = [word];
              if (word.trim().length > 0){
                lineNumber += 1;
                tspan = text.append('tspan').attr('x', 0).attr('y', 0).attr('dy', lineNumber * lineHeight + dy + 'px').text(word);

              }
            } else {
              line = [word]
            }
          }
        }
      });
    }
    this.stop(10).then(() => this.isLoading = false);
  }
  // property & data for the chart
  getControlChartData() {
    this.ControlChartData['properties'] = this.parentData
    this.ControlChartData['data'] = _.sortBy(this.data, this.item.config['x_axis']["api_resp_column_nm"])

    if (this.ControlChartData['properties'].length == 0 || this.ControlChartData['data'].length == 0) {
      this.noData = true; this.noDataNotifier.report('control-chart')
      this.isLoading = false
    }
    
    if (this.routeType == 'multi') {
      const [x_var,x_var1] = this.item.config.x_var.split(',')
      const [y_var,y_var1] = this.item.config.y_var.split(',')
      let currentSelections: any = sessionStorage.getItem("currentSelections");
      currentSelections = JSON.parse(currentSelections);
      this.ControlChartData['properties'] = this.ControlChartData['properties'].filter((item1: any) => {
        return currentSelections.some((item2: any) => {
          return (item1[x_var] == item2[x_var1] && item1[y_var] == item2[y_var1])
        });
      }).map((item: any) => {
        return item;
      });


      this.ControlChartData['data'] = this.ControlChartData['data'].filter((item1: any) => {
        return currentSelections.some((item2: any) => {
          return (item1[x_var] == item2[x_var1] && item1[y_var] == item2[y_var1])
        });
      }).map((item: any) => {
        return item;
      });
      //sort
      this.ControlChartData['data'] = this.ControlChartData['data'].sort((a: any, b: any) => {
        const indexA = currentSelections.find((item: any) =>  a[x_var]?.toString() === item[x_var1]?.toString() && a[y_var]?.toString() === item[y_var1]?.toString())?.index || 0;
        const indexB = currentSelections.find((item: any) =>  b[x_var]?.toString() === item[x_var1]?.toString() && b[y_var]?.toString() === item[y_var1]?.toString())?.index || 0;
        return indexA - indexB;
      });
     
    }
    let result: any = []

    // comments
     const [chart_var,chart_var1] = this.item.config.chart_data.split(',')
     const [cmt_var,cmt_var1] = this.item.config.comments_data.split(',')
     
    this.ControlChartData['data'].forEach((item1: any) => {
      return this.AllcommentData?.some((item2: any) => {
        if (moment(new Date(item1.period)).format("yyyy-MM-DD HH:mm:ss") == moment(new Date(item2.period)).format("yyyy-MM-DD HH:mm:ss") && item1[chart_var]?.toString() === item2[cmt_var]?.toString() && item1[chart_var1]?.toString() === item2[cmt_var1]?.toString()) {
          item1['comments'] = 'yes'
        } else {
          // item1['comments']= null
        }
        result.push(item1)
      });
    })
    result = [...new Set(result)]
    
    this.ControlChartData['data'] = result.length == 0 ? this.ControlChartData['data'] : result;
    this.ControlChartData['properties'].forEach((element: any) => {
      return element["showCalculations"] = "true"
    });
    this.ControlChartData['properties'].forEach((element: any) => {
      return element["buffer_range"] = element["buffer_range"] > 0 ? element["buffer_range"] / 100 : element["buffer_range"]
    });
    let propscontrol: any
    if (this.ControlChartData['properties'].length == 1) {
      propscontrol = this.ControlChartData['properties'][0]
      this.calculationStd.calculationControlChart(this.ControlChartData['data'], propscontrol)
    } else {
      const [x_var,x_var1] = this.item.config.x_var.split(',')
      const [y_var,y_var1] = this.item.config.y_var.split(',')
      this.calculationStd.multiControlchartCalculation(this.ControlChartData['properties'], this.ControlChartData['data'],[x_var,y_var])
    }
    

    if(this.item.config?.['show_data_point']?.value === true || this.item.config?.['show_data_point']?.value === 'true'){
   this.getLastNObjectsByDate(this.ControlChartData['data'],this.item.config?.['data_point'],'period')
   console.log(this.ControlChartData['properties'],this.ControlChartData['data']);
    }
     
    this.props = {
      sourceVar:this.item.config['group_value_column']["api_resp_column_nm"],//'source_name',
      kpiVar:  this.item.config['value_column']["api_resp_column_nm"],//this.item.config["list_of_api"]=='100185'?'kpi_nm': 'file_type_name',
      dateVar: this.item.config['x_axis']["api_resp_column_nm"],//'period',
      valueVar: this.item.config["y_axis"]["api_resp_column_nm"],//'kpi_value',
      // numberVar: 'kpi_value',
      period: this.filterService.report_type,
      thresholdVars: ["lower_threshold", "upper_threshold"],
      bufferVar: "buffer_range",
      lookBackVar: "look_back_period",
      sDVar: "no_of_std_deviations",
      colors: ["#D11044", "#FFCD4A", "#3AC97C"],
      commentColor: "#FF6636",
      colorLabels: ["anomaly", "buffer values", "normal"],
      legendItems:this.item.config['legend_items'] ? this.item.config['legend_items'].filter((d:any)=>d.selected==true): [
        { label: "anomaly", fill: "#D11044", stroke: "#D11044", "symbol": "", "symbolFill": "transparent" },
        // { label: "buffer values", fill: "#FFCD4A", stroke: "#FFCD4A", "symbol": "", "symbolFill": "transparent" },
        { label: "normal", fill: "#3AC97C", stroke: "#3AC97C", "symbol": "", "symbolFill": "transparent" },
        { label: "upper/lower control limits", fill: "white", stroke: "#E8EAEE", "symbol": "...", "symbolFill": "#FFCD4A", "symbolDY": 1 },
        { label: "upper/lower thresholds", fill: "#F9F7F7", stroke: "#E8EAEE", "symbol": "", "symbolFill": "transparent" },
        { label: "mean (avg)", fill: "white", stroke: "#E8EAEE", "symbol": "_", "symbolFill": "#6A76A9", "symbolDY": -1 }
      ],
      numberFormat: ",",
      minChartHeight: 180,
      singleChartHeight: 320,
      d3AxisFormatting: false,
      xAxisLabel: this.item.config?.['x_axis_label'] || this.item.config['x_axis']["api_resp_column_display_nm"].toUpperCase(),
      yAxisLabel: this.item.config?.['Y_axis_label'] || this.item.config['y_axis']["api_resp_column_display_nm"].toUpperCase(),
      xAxisVisible: true,
      showMeanLine: this.routeType == 'single' ? false : true,
      showDragSelect: (this.filterService?.annotations == true  || this.item.config["static_plot"]?.value) ? false : true,
      staticPlot:  (this.item.config?.['show_data_point']?.value === true || this.item.config?.['show_data_point']?.value === 'true')? true : false,
      slider: this.item.config?.['zoom_slider']?.value=='true' || false,
    }
    this.props.singleChartHeight = this.props.staticPlot ? 400 : 340
    if (this.item.config["list_of_api"]=='200212' || (this.item.config?.['show_data_point']?.value === true || this.item.config?.['show_data_point']?.value === 'true')) {
     this.props.legendItems = [
      { label: "anomaly", fill: "#D11044", stroke: "#D11044", "symbol": "", "symbolFill": "transparent" },
      // { label: "buffer values", fill: "#FFCD4A", stroke: "#FFCD4A", "symbol": "", "symbolFill": "transparent" },
      { label: "normal", fill: "#3AC97C", stroke: "#3AC97C", "symbol": "", "symbolFill": "transparent" },
      { label: "upper/lower control limits", fill: "white", stroke: "#E8EAEE", "symbol": "...", "symbolFill": "#FFCD4A", "symbolDY": 1 },
      // { label: "upper/lower thresholds", fill: "#F9F7F7", stroke: "#E8EAEE", "symbol": "", "symbolFill": "transparent" },
      { label: "mean (avg)", fill: "white", stroke: "#E8EAEE", "symbol": "_", "symbolFill": "#6A76A9", "symbolDY": -1 }
    ]
    }
    if (this.isFullscreen) {
      this.props.singleChartHeight = window.outerHeight - 200;
    }
    if(this.ControlChartData['data'].length > 0){
    // 1. Get the string from storage
    const storedData = sessionStorage.getItem("navHeaderData");

    if (storedData) {
      // 2. Convert string back to a JavaScript Object
     let header = JSON.parse(storedData);
     const period=this.item.config['x_axis']["api_resp_column_nm"]
     const dataValue =this.ControlChartData.data
      // 3. Update the specific value (e.g., source_name)
      header['cycle_dt']= moment(dataValue[dataValue.length-1][period]).format('DD MMM ')+' '

      // 4. Save it back to sessionStorage
      sessionStorage.setItem("navHeaderData", JSON.stringify(header));
      let headerName = this.item.config?.widget_header_config?.find((fnd: any) => fnd.value == "page_header")
        const value: any = JSON.parse(sessionStorage.getItem("navHeaderData") || '');
      let arr = headerName.nav_header_var.split(",");
      this.navHeading=''
      arr.forEach((m: any) => {
        this.navHeading += " " + value[m];
      });
    }
    }
    if (this.ControlChartData['properties'].length > 0 && this.ControlChartData['data'].length > 0) {
      this.noData = false
      setTimeout(() => {
        this.plotChart();
      }, 100);
    } else {
      // this.ControlChartData = [];
      // this.plotChart();
      this.noData = true; this.noDataNotifier.report('control-chart')
      this.isLoading = false

    }
  }
  getLastNObjectsByDate(dataArray: any, count: number, dateField: string) {
    // Sort the array by date in descending order
    // const sortedArray = _.orderBy(dataArray, [dateField], ['asc']);
    this.ControlChartData['data'] =dataArray.slice(-count);
    // Get the last N objects
    // return sortedArray.slice(0, count);
  }
  // Number Format
  numbedPipe(value: any) {
    return this.currency.transform(value, '', '', '1.0-2');
  }
  // Annotations methods
  editComment(message: any, event: any, i: any) {
    this.editedValue = this.CommentData.comments
    this.editIndex = this.commentIndex
    this.edit = true
  }
  getCurrentDate(date: any) {
    if (date) {
      return moment(date).format('MM/DD/YYYY HH:mm')
    } else {
      return moment().format('MM/DD/YYYY HH:mm')
    }
  }
  deleteComment(data?: any, index?: any) {
    let deletert: any
    // deletert = this.paramsData.params.item.config?.['report_type_selection'].find((val:any)=>val.action_typ ==  "DELETE")

    let postdata = {
      "report_typ": "D",//deletert.report_typ ||
      "user_comments_key": this.CommentData.user_comments_key
    }
    this.loadCommentsData(postdata)
    this.messages.splice(this.commentIndex, 1);
    if (this.messages.length == 0) {
      this.ControlChartData['data'].forEach((item1: any) => {
        if (moment(item1.period).format("yyyy-MM-DD HH:mm:ss") == moment(this.myAnnotationsData.period).format("yyyy-MM-DD HH:mm:ss") && item1.kpi_key === this.myAnnotationsData.kpi_key && item1.source_key === this.myAnnotationsData.source_key) {
          item1['comments'] = null
        }
        return item1

      })
      this.AllcommentData = []
      this.plotChart()
    }
  }
  getcomentData(message: any, i: any) {
    this.CommentData = message
    this.commentIndex = i
  }
  DelDialog(enterAnimationDuration: string, exitAnimationDuration: string): void {
    // this.dialog.open(this.DeleteDialog, {
    //   width: '250px',
    //   enterAnimationDuration,
    //   exitAnimationDuration,
    // });

    let dialogRef = this.dialog.open(PopupDeleteComponent, {
      maxWidth: '90vw',
      disableClose: true,
      panelClass: "du-custom-modalbox",
      data: 'annotation'
    });

    dialogRef.afterClosed().subscribe((value) => {

      if (value == '1') {
        this.deleteComment()
      }
    });

  }
  getMSGHtml(data: any) {
    data = data.replaceAll(' ', '&nbsp;')
    data = data.replaceAll('\n', '<br>')
    return data
  }
  messageData(value: any, e: any): void {
    // debugger
    e.preventDefault();
    e.stopPropagation()
    if (!value.trim()) { this.searchValue = ''; return }
    this.searchValue = value
    if (value == '') return
    let insert: any
    // insert = this.paramsData.params.item.config?.['report_type_selection'].find((val:any)=>val.action_typ ==  "INSERT")
   
    let postdata: any 
    if (this.item.config?.comment_type?.value == "dpmed" || this.item.config?.comment_type == "demd") {
      postdata = {
        "report_typ": "I",//insert.report_typ||
        "comments": this.searchValue,
        "kpi_key": this.currenttooltipdata?.['kpi_key'],
        "data_source_key": this.currenttooltipdata?.source_key ||this.filterService.baseQuery?.['source_key'] || undefined,
        "period": this.hasTimeDetails(this.myAnnotationsData.period) ? moment(this.myAnnotationsData.period).format("yyyy-MM-DD HH:mm:ss"): moment(this.myAnnotationsData.period).format("yyyy-MM-DD"),
        'file_type_dim_key': this.currenttooltipdata.file_type_dim_key || this.filterService.baseQuery?.['file_type_dim_key'] || undefined,
        'refresh_no' : this.currenttooltipdata?.refresh_seq_no|| undefined
      }
    } else {
      postdata = {
        "report_typ": "I",//insert.report_typ||
        "comments": this.searchValue,
        "kpi_key": this.filterService.baseQuery?.['kpi_key'],
        "data_source_key": this.currenttooltipdata.source_key || undefined,
        "period": moment(this.myAnnotationsData.period).format("yyyy-MM-DD"),
        'refresh_no' : this.currenttooltipdata?.refresh_seq_no|| undefined
      }
    }

    let noteConfig = this.item.config?.["notes_selected_key"] || [];
    if(noteConfig && noteConfig.length>0) {
      postdata["conversation_key"] = "";
      postdata["conversation_key"] = noteConfig
        .map((element: any) => element.api_resp_column_nm == 'period' ? moment(this.currenttooltipdata[element.api_resp_column_nm]).format('MM-DD-YYYY') : this.currenttooltipdata[element.api_resp_column_nm])
        .join(' - ');
    }

     if (this.previousStatus != this.status ) {
      postdata['is_comment_pinned'] = 'Y';
      this.InsertAmomaly()
      
  }
    this.loadCommentsData(postdata)
    //   this.messages.push({
    //     "user_comments_key": 23,
    //     "client_key": 2001,
    //     "brand_key": 200104,
    //     "data_source_key": 3004,
    //     "sp_location_key": null,
    //     "employee_key": 100119,
    //     "employee_name": "Boopathi A",
    //     "comments": this.searchValue,
    // })
    this.searchValue = ''
    document.getElementById('comment')?.focus()
    this.myFunction()
  }
  myFunction(): void {
    setTimeout(() => {

      const element: any = document.getElementById("content");
      element?.scrollIntoView({ block: 'end', behavior: 'smooth' });
    }, 200);
  }
  // Annotation update function
  SaveEdit(message: any, index: any) {
    if (!this.editedValue.trim()) { this.editedValue = ''; return }
    if (this.editedValue == '') return
    let update: any
    // update= this.paramsData.params.item.config?.['report_type_selection'].find((val:any)=>val.action_typ ==  "UPDATE")

    let postdata = {
      "user_comments_key": message.user_comments_key,
      "report_typ": "U",// update.report_typ ||
      "comments": this.editedValue,
    }
    this.loadCommentsData(postdata)
    this.messages[index].comments = this.editedValue
    this.messages[index].update_timestamp = moment().format('MM/DD/YYYY HH:mm')
    this.edit = false

  }
  editedChanges(updatedDate: any) {
    if (updatedDate == null) { return false } else {
      let start_Date: any = moment(updatedDate);
      let end_Date: any = moment(new Date());
      let totalDays: any = end_Date.diff(start_Date, 'days');
      if (totalDays <= 2) {

        return true
      } else {
        return false
      }
    }
  }
  getStyles() {

    return { width: "100%", height: "170px", 'overflow-y': "auto" }
  }
  /**
   * Which comment bucket this chart reads from and writes to.
   *
   * The DPM dashboard and any widget explicitly configured as "dpmed" keep their own
   * threads, named by the widget's `comment_type` (falling back to 'CC' when the widget
   * carries no config). Every other control chart shares the generic 'CCO' bucket.
   *
   * `dashboardKey` arrives as a decrypted query param, so it can be a string — the loose
   * comparison against the numeric key is deliberate.
   */
  get commentTyp(): string {
    debugger
    const commentType = this.item?.config?.comment_type?.value|| this.item?.config?.comment_type;
    return (this.dashboardKey == DPM_DASHBOARD_KEY || commentType == 'dpmed'||commentType == 'demd')
      ? (commentType || 'CC')
      : 'CCO';
  }

  loadCommentsData(data: any) {
    data['comment_typ'] = this.commentTyp
    data['api_key'] = 100132;
    // data['dashboard_key']= this.dashboardKey
    
    if(this.item.config?.["notes_selected_key"]) {
      data['dashboard_key']= this.dashboardKey
    } else {
      data['dashboard_key']= this.dashboardService.dashboardKey
    }

    this.reqSubcription.push(this.filterService.commentsQuery(data).subscribe((res: any) => {
      if (data.report_typ == 'I') {
        let commentsvalue = res ? res : []
        this.messages = commentsvalue
        this.myFunction()
        this.setMessages(this.messages)
        if (this.messages.length < 2) {
          this.getcommentsicon();
        }
        
        this.dialogService.customSnackBar('success', 'green', 'Message Added Successfully');
      }

      // Delete Snackbar
      if(data.report_typ == 'D') {
        this.dialogService.customSnackBar('success', 'green', 'Message Deleted Successfully');
      }

      // Update Snackbar
      if(data.report_typ == 'U') {
        this.dialogService.customSnackBar('success', 'green', 'Message Updated Successfully');
      }

    }))
  }

  getcommentsData() {
    // API Payloads
    let postdata: any = { report_typ: "S", comment_typ: this.commentTyp, api_key: "100132" };
    this.reqSubcription.push(this.filterService.commentsQuery(postdata).subscribe((res: any) => {
      this.AllcommentData = res ? res : [];
    }, err => {
      console.log("Control Chart Comment Api Error")
      this.AllcommentData = []
    }));
  }
    InsertAmomaly() {
      let postdata: any = {
          "kpi_key": this.filterService.baseQuery?.['kpi_key'] || this.currenttooltipdata?.['kpi_key'],
          "time_cycle": this.filterService.report_type,
          "chart_x_value": this.currenttooltipdata.source_name,
          "period":moment(this.myAnnotationsData.period).format("yyyy-MM-DD"),
          "updated_status": this.status,
          "comments": this.searchValue
           }
        this.reqSubcription.push(this.filterService.anomalyQuery(postdata).subscribe((res: any) => {
          if(res==true){
            this.dialogService.customSnackBar('success', 'green', 'Anomaly Updated Successfully');
            this.previousStatus=this.status
            this.ControlChartData['data'].forEach((item: any) => {
              if (moment(item.period).format("yyyy-MM-DD HH:mm:ss") == moment(this.myAnnotationsData.period).format("yyyy-MM-DD HH:mm:ss") && item.kpi_key === this.myAnnotationsData.kpi_key && item.source_key === this.myAnnotationsData.source_key) {
                item['status'] = this.status
                item['updated_status'] = this.status
               
              }
             })
             this.plotChart()
            }
        }, err => {
        console.log("Control Chart Amomaly Api Error")
        }));
      this.searchValue = ''
      }

  getcommentsicon() {
    let postdata: any = { report_typ: "S", comment_typ: this.commentTyp, api_key: "100132" };
    this.reqSubcription.push(this.filterService.commentsQuery(postdata).subscribe((res: any) => {
      this.AllcommentData = res ? res : [];
      this.getControlChartData()
    }, err => {
      console.log('Control Chart Comment Api Error')
      this.AllcommentData = []
    }));
  }
  hasTimeDetails(date: Date | null | undefined): boolean {
    if (!date) return false;
    const parsedDate = new Date(date);
    return parsedDate.getHours() !== 0 || parsedDate.getMinutes() !== 0 || parsedDate.getSeconds() !== 0;
  }
  ngOnDestroy(): void {
    sessionStorage.removeItem("navHeaderData");
    this.reqSubcription.forEach((res) => res.unsubscribe());
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
  }
 

onStatusToggle(event:MatSlideToggleChange) {
  const newStatus =   event.checked ? 'anomaly' : 'normal';

  console.log('Status changed from', this.status, 'to', newStatus);

  // this.previousStatus = this.status;
  this.status = newStatus;

  // Optional: react to change
  if (this.previousStatus != this.status ) {
    // Handle Anomaly → Normal
    document.getElementById('comment')?.focus()
  } else if (this.previousStatus === 'normal' && newStatus === 'anomaly') {
    // Handle Normal → Anomaly
  }
}

setMessages(messages: any[]): void {
   this.latestPinnedComment = null;
  if (!messages) return;

  // Step 1: Get pinned comments
  const pinnedComments = messages.filter(m => m.is_comment_pinned === 'Y');

  // Step 2: Find latest pinned
  this.latestPinnedComment = pinnedComments.length
    ? pinnedComments.reduce((latest, current) =>
        new Date(current.insert_timestamp) > new Date(latest.insert_timestamp) ? current : latest
      )
    : null;

  // Step 3: Keep all others except the latest pinned one
  this.messages = messages.filter(m => m !== this.latestPinnedComment);
}
setpinnedMessages(messages: any[]): void {
   this.latestPinnedComment = null;
  if (!messages) return;

  // Step 1: Get pinned comments
  const pinnedComments = messages.filter(m => m.is_comment_pinned === 'Y');

  // Step 2: Find latest pinned
  this.latestPinnedComment = pinnedComments.length
    ? pinnedComments.reduce((latest, current) =>
        new Date(current.insert_timestamp) > new Date(latest.insert_timestamp) ? current : latest
      )
    : null;

  // Step 3: Keep all others except the latest pinned one
  this.pinningmessages = messages.filter(m => m !== this.latestPinnedComment);
}
}